<template>
    <div>
        <Loader v-if="isLoading"></Loader>
        <div class="container">
            <div class="page-inner">
                <div class="page-header gp-admin-page-heading">
                    <h3 class="fw-bold">Nova contratação</h3>
                    <ul class="breadcrumbs">
                        <li class="nav-home"><router-link to="/home"><i class="fa fa-home"></i></router-link></li>
                        <li class="separator"><i class="fa fa-chevron-right"></i></li>
                        <li class="nav-item"><router-link to="/ListaContratacoes">Contratações</router-link></li>
                        <li class="separator"><i class="fa fa-chevron-right"></i></li>
                        <li class="nav-item"><span>Nova contratação</span></li>
                    </ul>
                </div>
                <div class="row" v-if="exibirFormulario">
                    <div class="col-md-12">
                        <div class="card gp-new-contract-card">
                            <div class="card-header">
                                <div class="d-flex align-items-center">
                                    <h4 class="card-title">Contratação Garantia Locatícia</h4>
                                </div>
                            </div>
                            <div class="card-body">
                                <v-tabs v-model="tab" class="gp-client-tabs" color="#102a5a" show-arrows>
                                    <v-tab value="dados" class="tabinfo"><v-icon start size="17">mdi-file-document-plus-outline</v-icon>Nova Contratação</v-tab>
                                </v-tabs>
                                <div class="gp-contract-steps" role="navigation" aria-label="Etapas da contratação">
                                    <button v-for="etapa in etapasContratacao" :key="etapa.id" type="button"
                                        :class="['gp-contract-step', { 'is-active': etapaAtual === etapa.id, 'is-done': etapaAtual > etapa.id }]"
                                        @click="IrParaEtapa(etapa.id)">
                                        <span class="gp-contract-step-number"><v-icon v-if="etapaAtual > etapa.id" size="15">mdi-check</v-icon><template v-else>{{ etapa.id }}</template></span>
                                        <span><strong>{{ etapa.nome }}</strong><small>{{ etapa.descricao }}</small></span>
                                    </button>
                                </div>
                                <v-window v-model="tab">
                                    <v-window-item value="dados">
                                        <v-form>
                                            <v-container>
                                                <v-row>
                                                    <v-col cols="12" md="12">
                                                        <v-card v-show="etapaAtual === 1" class="gp-contract-section-card">
                                                            <div class="gp-contract-section-heading"><span><v-icon size="18">mdi-account-group-outline</v-icon></span><div><h5>Pessoas da contratação</h5><small>Selecione garantidora, imobiliária e cliente.</small></div></div>
                                                            <v-row style="padding-bottom:20px;">
                                                                <v-col cols="12">
                                                                    <v-row v-if="User.garid == 0">
                                                                        <v-col cols="12" md="12">
                                                                            <label>Garantidora</label>
                                                                            <v-autocomplete v-model="selectedGarantidora" :items="DadosGarantidora" item-title="garNomeEmpresa" item-value="garId"
                                                                                density="compact" variant="outlined" placeholder="Digite para pesquisar" clearable hide-details
                                                                                no-data-text="Nenhum registro encontrado" @update:model-value="BuscaImobialiarias()" return-object />
                                                                        </v-col>
                                                                    </v-row>
                                                                    <v-row v-if="User.tpeid != 3">
                                                                        <v-col cols="12" md="12"
                                                                            v-if="selectedGarantidora != '' && selectedGarantidora != null && ListImobiliarias != ''">
                                                                            <label>Imobiliária</label>
                                                                            <v-autocomplete v-model="selectedImobiliaria" :items="ListImobiliarias" :item-title="TituloImobiliaria" item-value="imoId"
                                                                                density="compact" variant="outlined" placeholder="Digite para pesquisar" clearable hide-details
                                                                                no-data-text="Nenhum registro encontrado" @update:model-value="SelecionarConsumidor()" return-object />
                                                                        </v-col>
                                                                    </v-row>
                                                                    <v-row>
                                                                        <v-col cols="12" md="12"
                                                                            v-if="selectedImobiliaria != '' && selectedImobiliaria != null && ListConsumidor != ''">
                                                                            <label>Cliente</label>
                                                                            <v-autocomplete v-model="selectedConsumidor" :items="ListConsumidor"
                                                                                :item-title="TituloCliente" item-value="cliId" density="compact"
                                                                                variant="outlined" placeholder="Digite para pesquisar" clearable hide-details
                                                                                no-data-text="Nenhum registro encontrado" return-object
                                                                                @update:model-value="ValidaConsumidor()" />
                                                                        </v-col>
                                                                    </v-row>
                                                                    <v-row>
                                                                        <v-col cols="12" md="12"
                                                                            v-if="(selectedConsumidor == '' || selectedConsumidor == null) && selectedImobiliaria != '' && selectedImobiliaria != null">
                                                                            <button type="button" class="btn btn-info" @click="AbrirCadastroClienteRapido()">
                                                                                <v-icon size="16">mdi-account-plus-outline</v-icon> Novo Cliente
                                                                            </button>
                                                                        </v-col>
                                                                    </v-row>
                                                                </v-col>
                                                            </v-row>
                                                        </v-card>
                                                        <v-card v-show="etapaAtual === 3" class="gp-contract-section-card"
                                                            v-if="endereco != '' && tipoImovel != ''">
                                                            <div class="gp-contract-section-heading"><span><v-icon size="18">mdi-shield-home-outline</v-icon></span><div><h5>Garantia locatícia</h5><small>Selecione o produto e configure a cobertura.</small></div></div>
                                                            <v-item-group v-model="ProdutoSelected">
                                                                <v-container>
                                                                    <v-row>
                                                                        <h5 class="subtitulo"
                                                                            style="padding-bottom: 15px;padding-left:10px;">
                                                                            Selecione o produto</h5>
                                                                    </v-row>
                                                                    <v-row>
                                                                        <v-col v-for="mens in ListProdutos"
                                                                            :key="mens.proId" cols="12" md="6">
                                                                            <v-item>
                                                                                <v-card class="d-flex align-center" dark
                                                                                    height="230" @click="toggle(mens)"
                                                                                    :class="{ 'border-green': ProdutoSelected === mens }">
                                                                                    <div class="flex-grow-1 text-center"
                                                                                        style="justify-content: center;">
                                                                                        <img :src="buildFileUrl(mens.proProdutos.proCampoExtra10)"
                                                                                            style="height: 150px;"
                                                                                            class="mx-auto" />
                                                                                        {{ mens.nomeConcatenado }}
                                                                                    </div>
                                                                                    <v-icon
                                                                                        v-if="ProdutoSelected === mens"
                                                                                        class="check-icon">mdi-check</v-icon>
                                                                                </v-card>
                                                                            </v-item>
                                                                        </v-col>
                                                                    </v-row>
                                                                </v-container>
                                                            </v-item-group>
                                                        </v-card>
                                                    </v-col>
                                                    <v-col cols="12" md="12" v-if="liberaEndGarantia">
                                                        <v-card v-show="etapaAtual === 2" class="gp-contract-section-card">
                                                            <div class="gp-contract-section-heading"><span><v-icon size="18">mdi-map-marker-outline</v-icon></span><div><h5>Imóvel da contratação</h5><small>Informe o endereço que receberá a garantia.</small></div></div>
                                                            <v-row style="line-height: 0;">
                                                                <v-col cols="12"
                                                                    v-if="endereco == '' || endereco == null">
                                                                    <br><button class="btn btn-info"
                                                                        @click.prevent="dialogEndereco = true">Adicionar
                                                                        Endereço da Contratação</button>
                                                                </v-col>
                                                                <v-col cols="12" v-else>
                                                                    <br><button class="btn btn-info"
                                                                        @click.prevent="dialogEndereco = true">Editar
                                                                        Endereço da Contratação</button>
                                                                </v-col>
                                                            </v-row>
                                                            <v-row v-if="endereco != '' && endereco != null">
                                                                <v-col cols="12" style="line-height: 0;">
                                                                    <small><strong>Endereço:</strong> {{ endereco }} -
                                                                        {{ numeroend }}<template v-if="complemento"> - {{ complemento }}</template></small>
                                                                </v-col>
                                                                <v-col cols="12" style="line-height: 0;">
                                                                    <small><strong>CEP: </strong>{{ numCep }}</small>
                                                                </v-col>
                                                                <v-col cols="12" style="line-height: 0;">
                                                                    <small><strong>Cidade:</strong> {{ nomeCidade }} /
                                                                        {{ siglaEstado }} - {{ nomeBairro }}</small>
                                                                </v-col>
                                                                <v-col cols="12" style="line-height: 0;" v-if="residencialTipo!=''">
                                                                    <small><strong>Tipo Imóvel:</strong> {{ tipoImovel
                                                                        }} {{ residencialTipo }}</small>
                                                                </v-col>
                                                            </v-row>
                                                        </v-card>
                                                        <v-card v-show="etapaAtual === 3" class="gp-contract-section-card"
                                                            v-if="ListaPedidoItem != ''">
                                                            <div class="gp-contract-section-heading"><span><v-icon size="18">mdi-shield-check-outline</v-icon></span><div><h5>Itens da contratação</h5><small>Confira cobertura, valores e vigência da garantia.</small></div></div>
                                                            <div v-for="(produto, index) in ListaPedidoItem" :key="produto.pdiId || index" class="gp-contract-item-card">
                                                                <div class="gp-contract-item-title"><div><strong>{{ produto.nomeConcatenado || produto.proProdutos?.proNomeProduto }}</strong><small>Código {{ produto.proProdutos?.proId || '—' }}</small></div><div class="gp-contract-item-actions"><button type="button" class="is-edit" title="Editar valores do produto" @click="EditarProdutoContratacao(produto, index)"><v-icon size="17">mdi-pencil-outline</v-icon></button><button type="button" title="Remover item" @click="ExcluiProduto(index)"><v-icon size="17">mdi-trash-can-outline</v-icon></button></div></div>
                                                                <div class="gp-contract-item-details">
                                                                    <div><small>Cobertura</small><strong>{{ produto.cobertura || Qtdemultiplicador || '—' }}</strong></div>
                                                                    <div v-if="selectedImobiliaria && selectedImobiliaria.planoCoberturaLivre"><small>Forma de cálculo</small><strong>{{ produto.tipoCalculoTaxa === 'valor' ? 'Valor informado' : 'Taxa percentual' }}</strong></div>
                                                                    <div v-if="selectedImobiliaria && selectedImobiliaria.planoCoberturaLivre"><small>Taxa</small><strong>{{ formatarPercentualTaxa(produto.taxa) }}</strong></div>
                                                                    <div><small>Valor da garantia</small><strong>{{ formatarMoeda(Math.max(0, Number(produto.valorTotalProduto || 0) - parseValorDecimal(produto.codSetup))) }}</strong></div>
                                                                    <div><small>Setup</small><strong>{{ formatarMoeda(parseValorDecimal(produto.codSetup)) }}</strong></div>
                                                                    <div><small>Valor total</small><strong>{{ formatarMoeda(produto.valorTotalProduto) }}</strong></div>
                                                                </div>
                                                                <div class="gp-contract-item-validity"><v-icon size="15">mdi-calendar-range-outline</v-icon><span>Vigência de <strong>{{ formattedDate(produto.vigenciaini) }}</strong> até <strong>{{ formattedDate(produto.vigenciafim) }}</strong></span></div>
                                                            </div>
                                                        </v-card>
                                                        <v-card v-show="etapaAtual === 3" class="gp-contract-total-card"
                                                            v-if="ListaPedidoItem != ''">
                                                            <v-row>
                                                                <v-col cols="12" md="12">
                                                                    <div
                                                                        class="d-flex align-items-center justify-content-between">
                                                                        <h5 class="subtitulo">Total</h5>
                                                                        <h6 class="subtitulo">R$ {{
                                                                            parseFloat(TotalPedido).toFixed(2).toString().replace('.',
                                                                                ',')
                                                                        }}</h6>
                                                                    </div>
                                                                </v-col>
                                                            </v-row>
                                                        </v-card>
                                                        <v-card v-show="etapaAtual === 4" class="gp-contract-section-card" v-if="ListaFormasPagamento != ''">
                                                            <div class="gp-contract-section-heading"><span><v-icon size="18">mdi-credit-card-outline</v-icon></span><div><h5>Condição de pagamento</h5><small>Configure a entrada e o parcelamento do saldo.</small></div></div>
                                                            <div class="gp-payment-options">
                                                                <label class="gp-payment-check"><input v-model="pagamentoFlexivel.linkPagamento" type="checkbox" @change="AoAlterarLinkPagamento" /><span><strong>Link de pagamento</strong><small>Cobrança única pelo valor total da contratação.</small></span></label>
                                                                <label v-if="!pagamentoFlexivel.linkPagamento" class="gp-payment-check"><input v-model="pagamentoFlexivel.possuiEntrada" type="checkbox" @change="AoAlterarEntrada" /><span><strong>Possui entrada</strong><small>Informe um valor personalizado para descontar do saldo.</small></span></label>
                                                                <label v-if="!pagamentoFlexivel.linkPagamento && ValorSetupPagamento > 0" class="gp-payment-check"><input v-model="pagamentoFlexivel.setupNaEntrada" type="checkbox" @change="SalvarMemoria(2)" /><span><strong>Adicionar setup à entrada</strong><small>Setup de {{ formatarMoeda(ValorSetupPagamento) }}; desmarcado, será distribuído nas parcelas.</small></span></label>
                                                            </div>
                                                            <v-row v-if="!pagamentoFlexivel.linkPagamento">
                                                                <v-col v-if="pagamentoFlexivel.possuiEntrada" cols="12" md="6">
                                                                    <label>Valor personalizado da entrada</label>
                                                                    <input v-model="pagamentoFlexivel.valorEntrada" class="form-control" inputmode="decimal" placeholder="R$ 0,00" @input="NormalizarEntrada" />
                                                                </v-col>
                                                                <v-col v-if="pagamentoFlexivel.possuiEntrada || pagamentoFlexivel.setupNaEntrada" cols="12" md="6">
                                                                    <label>Forma de pagamento da entrada</label>
                                                                    <select v-model="pagamentoFlexivel.formaEntrada" class="form-select form-control" @change="SalvarMemoria(2)"><option :value="null">Selecione</option><option v-for="forma in FormasPagamentoSemLink" :key="`entrada-${forma.cfpId}`" :value="forma">{{ forma.cfpNome }}</option></select>
                                                                </v-col>
                                                                <v-col cols="12" md="6">
                                                                    <label>Quantidade de parcelas do saldo</label>
                                                                    <input v-model.number="pagamentoFlexivel.quantidadeParcelas" class="form-control" type="number" min="1" max="12" @input="LimitarParcelas" />
                                                                </v-col>
                                                                <v-col cols="12" md="6">
                                                                    <label>Forma de pagamento das parcelas</label>
                                                                    <select v-model="pagamentoFlexivel.formaParcelas" class="form-select form-control" @change="SalvarMemoria(2)"><option :value="null">Selecione</option><option v-for="forma in FormasPagamentoSemLink" :key="`parcelas-${forma.cfpId}`" :value="forma">{{ forma.cfpNome }}</option></select>
                                                                </v-col>
                                                            </v-row>
                                                            <div v-if="!pagamentoFlexivel.linkPagamento" class="gp-payment-summary">
                                                                <div v-if="ValorTotalEntrada > 0"><small>Entrada</small><strong>{{ formatarMoeda(ValorTotalEntrada) }}</strong><span>{{ pagamentoFlexivel.formaEntrada?.cfpNome || 'Forma não selecionada' }}</span></div>
                                                                <div><small>Saldo</small><strong>{{ pagamentoFlexivel.quantidadeParcelas }}x de {{ formatarMoeda(ValorParcelaFlexivel) }}</strong><span>{{ pagamentoFlexivel.formaParcelas?.cfpNome || 'Forma não selecionada' }}</span></div>
                                                                <div><small>Total</small><strong>{{ formatarMoeda(TotalPedido) }}</strong><span>Entrada + saldo parcelado</span></div>
                                                            </div>
                                                            <div v-else class="gp-payment-summary gp-payment-summary-link-only"><div><small>Valor total do link</small><strong>{{ formatarMoeda(TotalPedido) }}</strong><span>A cobrança será gerada em valor único.</span></div></div>
                                                        </v-card>
                                                        <v-card v-show="etapaAtual === 5" class="gp-contract-review-card">
                                                            <div class="gp-contract-section-heading"><span><v-icon size="18">mdi-clipboard-check-outline</v-icon></span><div><h5>Revisão da contratação</h5><small>Confira os dados antes de salvar.</small></div></div>
                                                            <div class="gp-review-grid">
                                                                <section><small>Pessoas</small><strong>{{ selectedConsumidor?.cliNomeEmpresa || 'Cliente não selecionado' }}</strong><span>{{ selectedGarantidora?.garNomeEmpresa }} · {{ selectedImobiliaria?.imoNomeEmpresa }}</span><button type="button" @click="etapaAtual = 1">Editar</button></section>
                                                                <section><small>Imóvel</small><strong>{{ endereco }}, {{ numeroend }}</strong><span>{{ nomeBairro }} · {{ nomeCidade }}/{{ siglaEstado }}</span><button type="button" @click="etapaAtual = 2">Editar</button></section>
                                                                <section><small>Garantia</small><strong>{{ ListaPedidoItem.length }} produto(s)</strong><span>Total: R$ {{ parseFloat(TotalPedido || 0).toFixed(2).replace('.', ',') }}</span><button type="button" @click="etapaAtual = 3">Editar</button></section>
                                                                <section><small>Pagamento</small><strong>{{ pagamentoFlexivel.linkPagamento ? 'Link de pagamento' : (ValorTotalEntrada > 0 ? `${formatarMoeda(ValorTotalEntrada)} de entrada` : 'Sem entrada') }}</strong><span>{{ pagamentoFlexivel.linkPagamento ? formatarMoeda(TotalPedido) : `${pagamentoFlexivel.quantidadeParcelas}x de ${formatarMoeda(ValorParcelaFlexivel)}` }}</span><button type="button" @click="etapaAtual = 4">Editar</button></section>
                                                            </div>
                                                            <div class="gp-review-alert"><v-icon size="18">mdi-information-outline</v-icon><span>Ao salvar, a contratação ficará em Aguardando Análise e poderá ser revisada antes do envio.</span></div>
                                                        </v-card>
                                                    </v-col>
                                                </v-row>
                                                <v-row class="gp-new-contract-actions">
                                                    <v-col cols="12" class="gp-contract-actionbar">
                                                        <button type="button" @click="CancelarFormulario()"
                                                            class="btn btn-outline-secondary">
                                                            Cancelar
                                                        </button>
                                                        <span class="gp-action-spacer"></span>
                                                        <button v-if="etapaAtual > 1" type="button" class="btn btn-outline-secondary" @click="VoltarEtapa()">Voltar</button>
                                                        <button v-if="etapaAtual < 5" type="button" class="btn btn-primary" @click="ProximaEtapa()">Continuar <v-icon size="16">mdi-arrow-right</v-icon></button>
                                                        <button v-if="etapaAtual === 5" type="button" class="btn btn-primary" :disabled="isLoading" @click="SalvarContratacao()">
                                                            <v-icon size="16">mdi-content-save-outline</v-icon> {{ isLoading ? 'Salvando...' : (pedidoEmRevisaoId ? 'Alterar contratação' : 'Salvar contratação') }}
                                                        </button>
                                                    </v-col> 
                                                </v-row>
                                            </v-container>
                                        </v-form>
                                    </v-window-item>
                                </v-window>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="!exibirFormulario">
                    <div class="col-md-12">
                        <div class="card gp-pending-contracts-card">
                            <div class="card-header">
                                <div class="d-flex align-items-center">
                                    <div>
                                        <h4 class="card-title">Contratações aguardando envio</h4>
                                        <small>Revise e encaminhe as contratações salvas em Aguardando Análise.</small>
                                    </div>
                                    <div class="ms-auto d-flex align-items-center gap-2">
                                        <span class="gp-pending-count">{{ PedidosAguardandoAnalise.length }}</span>
                                        <button type="button" class="btn btn-primary" @click="IniciarNovaContratacao()">
                                            <v-icon size="17">mdi-plus</v-icon> Iniciar nova contratação
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body">
                                <adm-data-table :headers="headersPedidosAguardando" :export-headers="headersPedidosAguardandoExportacao"
                                    :items="PedidosAguardandoAnalise" :filter-columns="4"
                                    total-field="pedValorTotalPedido" total-label="Valor total filtrado"
                                    file-name="contratacoes-aguardando-envio" alternating theme-color="#364f66"
                                    table-class-name="customize-table" header-text-direction="center"
                                    body-text-direction="center" rows-per-page-message="Linhas por pagina">
                                    <template #item-tipoContratacao="item">
                                        <span class="gp-contract-type" :class="item.pedCiclo > 1 ? 'is-renewal' : 'is-initial'">
                                            {{ item.pedCiclo > 1 ? `Renovação · ciclo ${item.pedCiclo}` : 'Inicial' }}
                                        </span>
                                    </template>
                                    <template #item-entidadesResumo="item"><div class="gp-pending-summary"><strong>{{ item.garNome || '—' }}</strong><small>{{ item.imobNome || '—' }}</small></div></template>
                                    <template #item-clienteResumo="item"><div class="gp-pending-summary"><strong>{{ item.cliNome || '—' }}</strong><small>{{ item.cliDocumento || '—' }}</small></div></template>
                                    <template #item-pedDataPedido="item">{{ formattedDate(item.pedDataPedido) }}</template>
                                    <template #item-pedValorTotalPedido="item">{{ formatarMoeda(item.pedValorTotalPedido) }}</template>
                                    <template #item-actions="item">
                                        <div class="gp-table-actions gp-pending-actions">
                                            <button type="button" class="gp-table-action gp-action-edit" title="Revisar dados" @click="RevisarPedido(item)"><v-icon size="17">mdi-file-search-outline</v-icon></button>
                                            <button v-if="item.pedCiclo <= 1" type="button" class="gp-pending-text-action is-analysis" @click="EnviarPedidoAnalise(item)">Enviar para análise</button>
                                            <button type="button" class="gp-pending-text-action is-direct" @click="EnviarPedidoSemAnalise(item)">Enviar sem análise</button>
                                            <button type="button" class="gp-table-action gp-action-delete" title="Cancelar contratação" @click="CancelarPedidoAguardando(item)"><v-icon size="17">mdi-close-circle-outline</v-icon></button>
                                        </div>
                                    </template>
                                </adm-data-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <v-dialog v-model="dialogClienteRapido" persistent class="gp-new-contract-dialog gp-quick-client-dialog">
            <v-card>
                <v-card-title>
                    <span class="gp-dialog-title"><v-icon size="19">mdi-account-plus-outline</v-icon>Cadastrar cliente</span>
                    <button type="button" class="gp-dialog-close" @click="dialogClienteRapido = false" aria-label="Fechar"><v-icon size="20">mdi-close</v-icon></button>
                </v-card-title>
                <v-card-text>
                    <div class="gp-quick-client-block">
                        <div class="gp-quick-client-heading"><strong>Dados do cliente</strong><small>O cliente será vinculado à garantidora e imobiliária selecionadas.</small></div>
                        <v-row>
                            <v-col cols="12" md="3"><label>Tipo pessoa *</label><select v-model="clienteRapido.tpdId" class="form-select form-control"><option :value="1">Pessoa física</option><option :value="2">Pessoa jurídica</option></select></v-col>
                            <v-col cols="12" md="5"><label>Nome *</label><input v-model.trim="clienteRapido.cliNomeEmpresa" class="form-control" placeholder="Nome completo ou empresa" /></v-col>
                            <v-col cols="12" md="4"><label>Documento *</label><input v-model.trim="clienteRapido.cliDocumento" class="form-control" placeholder="CPF ou CNPJ" /></v-col>
                            <v-col cols="12" md="4"><label>Telefone *</label><input v-model="clienteRapido.cliTelefone" v-mask="'(##) #####-####'" class="form-control" placeholder="(00) 00000-0000" /></v-col>
                            <v-col cols="12" md="4"><label>WhatsApp *</label><input v-model="clienteRapido.cliWhatsapp" v-mask="'(##) #####-####'" class="form-control" placeholder="(00) 00000-0000" /></v-col>
                            <v-col cols="12" md="4"><label>E-mail *</label><input v-model.trim="clienteRapido.cliEmail" type="email" class="form-control" placeholder="E-mail" /></v-col>
                            <template v-if="clienteRapido.tpdId === 1">
                                <v-col cols="12" md="4"><label>Data de nascimento *</label><input v-model="clienteRapido.cliDataNascimento" type="date" class="form-control" /></v-col>
                                <v-col cols="12" md="4"><label>Estado civil *</label><select v-model="clienteRapido.cliEstadoCivil" class="form-select form-control"><option :value="null">Selecione</option><option>Solteiro(a)</option><option>Casado(a)</option><option>União Estável</option><option>Divorciado(a)</option><option>Viúvo(a)</option></select></v-col>
                                <v-col cols="12" md="4"><label>Nome da mãe *</label><input v-model.trim="clienteRapido.cliNomeMae" class="form-control" placeholder="Nome da mãe" /></v-col>
                                <v-col cols="12" md="4"><label>Nome do pai *</label><input v-model.trim="clienteRapido.cliNomePai" class="form-control" placeholder="Nome do pai" /></v-col>
                            </template>
                            <template v-else>
                                <v-col cols="12" md="6"><label>Responsável *</label><input v-model.trim="clienteRapido.cliResponsavel" class="form-control" placeholder="Responsável legal" /></v-col>
                                <v-col cols="12" md="6"><label>CPF do responsável *</label><input v-model="clienteRapido.cliCampoExtra1" v-mask="'###.###.###-##'" class="form-control" placeholder="CPF" /></v-col>
                            </template>
                        </v-row>
                    </div>
                    <div class="gp-quick-client-block">
                        <div class="gp-quick-client-heading"><strong>Endereço cadastral</strong><small>Este endereço identifica o cliente; o endereço do imóvel será informado na próxima etapa.</small></div>
                        <v-row>
                            <v-col cols="12" md="3"><label>CEP *</label><input v-model="clienteRapidoEndereco.cleCep" v-mask="'#####-###'" class="form-control" placeholder="CEP" /></v-col>
                            <v-col cols="12" md="2" class="d-flex align-end"><button type="button" class="btn btn-secondary w-100" @click="BuscarCepClienteRapido()">Verificar</button></v-col>
                            <v-col cols="12" md="5"><label>Endereço *</label><input v-model.trim="clienteRapidoEndereco.cleEndereco" class="form-control" placeholder="Endereço" /></v-col>
                            <v-col cols="12" md="2"><label>Número *</label><input v-model.trim="clienteRapidoEndereco.cleNumero" class="form-control" placeholder="Número" /></v-col>
                            <v-col cols="12" md="3"><label>Complemento</label><input v-model.trim="clienteRapidoEndereco.cleComplemento" class="form-control" placeholder="Complemento" /></v-col>
                            <v-col cols="12" md="3"><label>Bairro *</label><input v-model.trim="clienteRapidoEndereco.cleBairro" class="form-control" placeholder="Bairro" /></v-col>
                            <v-col cols="12" md="4"><label>Cidade *</label><input v-model.trim="clienteRapidoEndereco.cleCidade" class="form-control" placeholder="Cidade" /></v-col>
                            <v-col cols="12" md="2"><label>UF *</label><input v-model.trim="clienteRapidoEndereco.cleEstado" maxlength="2" class="form-control" placeholder="UF" /></v-col>
                            <v-col cols="12">
                                <v-checkbox v-model="usarEnderecoClienteNaContratacao" color="#102a5a" density="compact" hide-details
                                    label="Usar este endereço também como endereço da contratação" />
                                <small class="gp-quick-address-note">O endereço será levado para a próxima etapa e ainda poderá ser revisado antes da contratação.</small>
                            </v-col>
                        </v-row>
                    </div>
                </v-card-text>
                <v-card-actions><v-spacer></v-spacer><v-btn class="gp-dialog-secondary-action" @click="dialogClienteRapido = false">Cancelar</v-btn><v-btn class="gp-dialog-primary-action" :disabled="salvandoClienteRapido" @click="SalvarClienteRapido()"><v-icon start size="16">mdi-content-save-outline</v-icon>{{ salvandoClienteRapido ? 'Salvando...' : 'Cadastrar e selecionar' }}</v-btn></v-card-actions>
            </v-card>
        </v-dialog>
        <!--modal endereco-->
        <v-row justify="center">
            <v-dialog v-model="dialogEndereco" persistent class="controlcelEnd gp-new-contract-dialog gp-address-dialog" transition="dialog-bottom-transition">
                <v-card>
                    <v-card-title>
                        <span class="gp-dialog-title"><v-icon size="19">mdi-map-marker-outline</v-icon>Cadastrar endereço do imóvel</span>
                        <button type="button" class="gp-dialog-close" @click="LimparEndereco()" aria-label="Fechar">
                            <v-icon size="20">mdi-close</v-icon>
                        </button>
                    </v-card-title>
                    <v-card-text style="padding: 16px 0px 10px">
                        <v-form>
                            <v-container>
                                <v-row>
                                    <v-col cols="12" md="5">
                                        <label>CEP</label>
                                        <input v-model="numCep" v-mask="'#####-###'" type="text" class="form-control"
                                            placeholder="CEP" />
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <a href="#" class="btn gp-address-search-button"
                                            @click.prevent="Buscacep(numCep)">Verificar</a>
                                    </v-col>
                                    <v-col cols="12" md="5" v-show="showend">
                                        <label>Endereço</label>
                                        <input v-model="endereco" type="text" class="form-control"
                                            placeholder="Endereço" />
                                    </v-col>
                                    <v-col cols="12" md="2" v-show="showend">
                                        <label>Número</label>
                                        <input v-model="numeroend" type="number" class="form-control"
                                            placeholder="Número" />
                                    </v-col>
                                    <v-col cols="12" md="2" v-show="showend">
                                        <label>Complemento</label>
                                        <input v-model="complemento" type="text" class="form-control"
                                            placeholder="Complemento" />
                                    </v-col>
                                    <v-col cols="12" md="3" v-show="showend">
                                        <label>Cidade</label>
                                        <input v-model="nomeCidade" type="text" class="form-control"
                                            placeholder="Cidade" />
                                    </v-col>
                                    <v-col cols="12" md="2" v-show="showend">
                                        <label>Estado</label>
                                        <input v-model="siglaEstado" type="text" v-mask="'AA'" class="form-control"
                                            placeholder="UF" />
                                    </v-col>
                                    <v-col cols="12" md="3" v-show="showend">
                                        <label>Bairro</label>
                                        <input v-model="nomeBairro" type="text" class="form-control"
                                            placeholder="Bairro" />
                                    </v-col>
                                    <v-col cols="12" md="4" v-show="showend">
                                    <label>Imóvel</label>
                                    <div class="gp-property-type-options">
                                        <button v-for="t in tiposImoveis" :key="t.id" type="button"
                                            :class="{ 'is-active': tipoImovel === t.id }"
                                            @click="tipoImovel = t.id; residencialTipo = null">
                                            <v-icon size="15">{{ t.id === 'Residencial' ? 'mdi-home-outline' : 'mdi-office-building-outline' }}</v-icon>
                                            {{ t.id }}
                                        </button>
                                    </div>
                                    </v-col>

                                    <v-col cols="12" md="3" v-show="showend && tipoImovel">
                                    <label>Tipo do imóvel</label>

                                    <v-select
                                        v-model="residencialTipo"
                                        :items="subtiposDisponiveis"
                                        item-title="nome"
                                        item-value="id"
                                        :disabled="!subtiposDisponiveis.length"
                                        density="compact"
                                        hide-details
                                        variant="outlined"
                                    />
                                    </v-col>

                                </v-row>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions v-show="showend">
                        <v-spacer></v-spacer>
                        <v-btn class="gp-dialog-primary-action"
                            @click.prevent="ValidaEndereco()">Confirmar Endereço</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>

        <!--modal produto garantia-->
        <v-row justify="center">
            <v-dialog v-model="dialogProdutoGarantia" persistent class="controlcelEnd gp-new-contract-dialog gp-product-dialog"
                transition="dialog-bottom-transition">
                <v-card>
                    <v-card-title>
                        <span class="gp-dialog-title"><v-icon size="19">mdi-shield-home-outline</v-icon>Produto Garantia {{ tipoImovel }}</span>
                        <button type="button" class="gp-dialog-close" @click="FecharModalProduto" aria-label="Fechar">
                            <v-icon size="20">mdi-close</v-icon>
                        </button>
                    </v-card-title>
                    <v-card-text style="padding: 16px 0px 10px">
                        <v-form>
                            <v-container>
                                <v-row>
                                    <v-col cols="12" md="6">
                                        <v-row v-for="(grids, index) in ProdutosGrid" :key="index"
                                            class="gp-product-value-row">
                                            <v-col cols="12" md="8" class="d-flex align-center gp-product-value-label">
                                                {{ grids.pisNome }}
                                            </v-col>
                                            <v-col cols="12" md="4">
                                                <v-text-field class="input" v-model="grids.pisCampoExtra1" v-decimal
                                                    variant="outlined" placeholder="Valor R$ "></v-text-field>
                                            </v-col>
                                        </v-row>
                                         <v-alert style="padding-top: 20;"
                                            density="compact"
                                            text="Valores zerados não entram em caso de sinistro."
                                            title="Aviso"
                                            type="warning"
                                        ></v-alert>
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <v-row>
                                            <v-col cols="12" md="12" v-if="!selectedImobiliaria.planoCoberturaLivre">
                                                <small>Selecione a cobertura:</small>
                                                <select v-model="CoberturaSelected" class="form-select form-control" @change="AtualizaTaxasPlanos()">
                                                    <option :value=null>Selecione</option>
                                                    <option v-for="(optionTipo, index) in ListaPlanosCobertura.filter(x=> x.ipcTipoCobertura == tipoImovel)"
                                                        :key="index" :value="optionTipo">{{ optionTipo.ipcCobertura }}x
                                                    </option>
                                                </select>
                                            </v-col>
                                            <v-col cols="12" md="12" v-if="selectedImobiliaria.planoCoberturaLivre">
                                                <small>Forma de cálculo:</small>
                                                <select v-model="TipoCalculoTaxa" class="form-select form-control"
                                                    @change="AtualizaTipoCalculoTaxa()">
                                                    <option value="taxa">Informar taxa</option>
                                                    <option value="valor">Informar valor do pacote</option>
                                                </select>
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-if="selectedImobiliaria.planoCoberturaLivre">
                                                <small>Cobertura (quantidade de vezes):</small>
                                                <input v-model="CoberturaLivreInput" type="number" min="1" step="1"
                                                    class="form-control" placeholder="Ex.: 24"
                                                    @change="PersistirCobertura()" />
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-if="selectedImobiliaria.planoCoberturaLivre && TipoCalculoTaxa == 'taxa'">
                                                <small>Taxa (%):</small>
                                                <div class="gp-percentage-input">
                                                    <input v-model="TaxaLivreInput" type="text" inputmode="decimal"
                                                        class="form-control" placeholder="Ex.: 11" />
                                                    <span>%</span>
                                                </div>
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-if="selectedImobiliaria.planoCoberturaLivre && TipoCalculoTaxa == 'valor'">
                                                <small>Valor do pacote R$:</small>
                                                <v-text-field class="input" v-model="ValorPacoteInformado" v-decimal
                                                    variant="outlined" placeholder="Valor R$"
                                                    @input="AtualizaTaxaPorValorPacote()"></v-text-field>
                                            </v-col>
                                            <v-col cols="12" md="12">
                                                <small>Digite o valor do Setup da Imobiliária R$:</small>
                                                <v-text-field class="input" v-model="PlanosGarantiasSelected" v-decimal
                                                    variant="outlined" placeholder="Valor R$ "></v-text-field>
                                            </v-col>
                                            <v-col cols="12" md="12" v-if="ControlaContratacoesPorDataVigencia">
                                                <small>Data de inicio da vigencia:</small>
                                                <v-text-field class="input" v-model="DataInicioVigenciaGarantia" type="date"
                                                    :min="DataMinimaVigencia" variant="outlined" @input="AjustaDataFimVigenciaGarantia()"></v-text-field>
                                            </v-col>
                                            <v-col cols="12" md="12" v-if="ControlaContratacoesPorDataVigencia">
                                                <small>Data final da vigencia:</small>
                                                <v-text-field class="input" v-model="DataFimVigenciaGarantia" type="date"
                                                    variant="outlined" disabled></v-text-field>
                                            </v-col>
                                            <v-col cols="12" md="12" class="gp-guarantee-result">
                                                <small class="gp-guarantee-result-title">Resultado</small>
                                                <v-card color="#f7f7f7"
                                                    v-if="ExibeResultadoGarantia">
                                                    Pacote: R$ {{ formatarValor(ValorPacoteGarantiaComputed)
                                                    }}<br>
                                                    Taxa: {{ formatarPercentualTaxa(TaxaGarantiaComputed)
                                                    }}<br>
                                                    Taxa Setup: R$ {{ formatarValor(parseValorDecimal(PlanosGarantiasSelected))
                                                    }}<br>
                                                    <strong>Valor Total: R$ {{
                                                        formatarValor(parseFloat(ValorPacoteGarantiaComputed) +
                                                            parseValorDecimal(PlanosGarantiasSelected)) }} </strong>
                                                </v-card>
                                                <small class="gp-guarantee-disclaimer">* Todos os valores informados são de responsabilidade da
                                                    imobiliária parceira.</small>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions v-show="showend">
                        <v-spacer></v-spacer>
                        <v-btn class="gp-dialog-secondary-action"
                            @click.prevent="FecharModalProduto">Cancelar</v-btn>
                        <v-btn class="gp-dialog-primary-action"
                            @click.prevent="AdicionarGarantia()">{{ produtoEmEdicaoIndex == null ? 'Adicionar Garantia' : 'Alterar Garantia' }}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
    </div>
</template>

<script>
import axios from 'axios';
import EasyDataTable from 'vue3-easy-data-table';
import moment from 'moment'
import Loader from '../../components/PageLoader.vue'


export default {
    name: 'NovaContratacaoGarantiaView',
    components: {
        EasyDataTable,
        moment,
        Loader
    },
    data: () => ({
        tab: null,
        etapaAtual: 1,
        etapasContratacao: [
            { id: 1, nome: 'Pessoas', descricao: 'Participantes' },
            { id: 2, nome: 'Imóvel', descricao: 'Endereço' },
            { id: 3, nome: 'Garantia', descricao: 'Cobertura' },
            { id: 4, nome: 'Pagamento', descricao: 'Cobrança' },
            { id: 5, nome: 'Revisão', descricao: 'Confirmação' }
        ],
        dialogClienteRapido: false,
        salvandoClienteRapido: false,
        usarEnderecoClienteNaContratacao: false,
        clienteRapido: { tpdId: 1, cliNomeEmpresa: '', cliDocumento: '', cliTelefone: '', cliWhatsapp: '', cliEmail: '', cliDataNascimento: '', cliEstadoCivil: null, cliNomeMae: '', cliNomePai: '', cliResponsavel: '', cliCampoExtra1: '' },
        clienteRapidoEndereco: { cleEndereco: '', cleNumero: '', cleComplemento: '', cleCep: '', clePais: 'Brasil', cleEstado: '', cleCidade: '', cleBairro: '', cleObsEndereco: '' },
        NomeTela: 'Contratação',
        InfoTela: 'Nova Contratação',
        CadastroTelas: [{ cdtId: 28, cdtNome: "Contratação" }],
          User: {
            garid:0,
            tpeid:0,
            pesid:0,
            cusid:0
        },
        //cli geral
        ListaFormasPagamento:[],
        DadosPagamento:[],
        TipoOperadoras:[],
        selectedFormaPagamento:null,
        pagamentoFlexivel: {
            linkPagamento: false,
            possuiEntrada: false,
            valorEntrada: '',
            setupNaEntrada: false,
            quantidadeParcelas: 12,
            formaEntrada: null,
            formaParcelas: null
        },
        ListClientesGeral: [],
        //garantidoras
        selectedGarantidora: null,
        //Imobiliarias
        ListImobiliariaGeral: [],
        selectedImobiliaria: null,
        ListImobiliarias: [],
        //Imobliarias
        //consumidor
        selectedConsumidor: null,
        ListConsumidor: [],
        Cliente: {},
        liberaEndGarantia: false,
        EnderecoContrato: [],
        //consumidor
        //endereco
        dialogEndereco: false,
        endereco: '',
        numeroend: '',
        complemento: '',
        siglaEstado: '',
        nomeCidade: '',
        nomeBairro: '',
        numCep: '',
        Observacoes: '',
        Retornocep: {},
        showend: false,
        //endereco
        //pedido
        Pedidos: [],
        PedidosCli: [],
        TotalPedido: 0,
        ValorDesconto: 0,
        ValorFrete: 0,
        ListaPedidoItem: [],
        ListaPedidoItemAdicional: [],
        Situacoes: [],
        //pedido
        //produtos
        ProdutoSelected: '',
        ListProdutosGeral: [],
        ListProdutos: [],
        selectedItemProduto: null,
        dialogProdutoGarantia: false,
        produtoEmEdicaoIndex: null,
        dialogProdutoSeguro: false,
        ProdutosGrid: [],
        PlanosGarantiasSelected: 0,
        PlanosGarantias: [],
        ProdutosTaxas: null,
        TipoCalculoTaxa: 'taxa',
        ValorPacoteInformado: null,
        DataInicioVigenciaGarantia: moment().add(1, 'day').format('YYYY-MM-DD'),
        DataFimVigenciaGarantia: moment().add(1, 'day').add(12, 'months').format('YYYY-MM-DD'),
     ListaProdutosTaxas: [
                { tipo: 'Residencial', Nome: 'Garantia Locatícia Residencial 3%', value: 0.03 },
                { tipo: 'Residencial', Nome: 'Garantia Locatícia Residencial 4%', value: 0.04 },
                { tipo: 'Residencial', Nome: 'Garantia Locatícia Residencial 5%', value: 0.05 },
                { tipo: 'Residencial', Nome: 'Garantia Locatícia Residencial 6%', value: 0.06 },
                { tipo: 'Residencial', Nome: 'Garantia Locatícia Residencial 7%', value: 0.07 },
                { tipo: 'Residencial', Nome: 'Garantia Locatícia Residencial 8%', value: 0.08 },
                { tipo: 'Residencial', Nome: 'Garantia Locatícia Residencial 9%', value: 0.09 },
                { tipo: 'Residencial', Nome: 'Garantia Locatícia Residencial 9,5%', value: 0.095 },
                { tipo: 'Residencial', Nome: 'Garantia Locatícia Residencial 10%', value: 0.10 },
                { tipo: 'Residencial', Nome: 'Garantia Locatícia Residencial 10,5%', value: 0.105 },
                { tipo: 'Residencial', Nome: 'Garantia Locatícia Residencial 11%', value: 0.11 },
                { tipo: 'Residencial', Nome: 'Garantia Locatícia Residencial 11,5%', value: 0.115 },
                { tipo: 'Residencial', Nome: 'Garantia Locatícia Residencial 12%', value: 0.12 },
                { tipo: 'Residencial', Nome: 'Garantia Locatícia Residencial 12,5%', value: 0.125 },
                { tipo: 'Residencial', Nome: 'Garantia Locatícia Residencial 13%', value: 0.13 },
                { tipo: 'Residencial', Nome: 'Garantia Locatícia Residencial 13,5%', value: 0.135 },
                { tipo: 'Residencial', Nome: 'Garantia Locatícia Residencial 14%', value: 0.14 },
                { tipo: 'Residencial', Nome: 'Garantia Locatícia Residencial 14,5%', value: 0.145 },
                { tipo: 'Residencial', Nome: 'Garantia Locatícia Residencial 15%', value: 0.15 },
                { tipo: 'Residencial', Nome: 'Garantia Locatícia Residencial 15,5%', value: 0.155 },
                { tipo: 'Residencial', Nome: 'Garantia Locatícia Residencial 16%', value: 0.16 },
                { tipo: 'Residencial', Nome: 'Garantia Locatícia Residencial 16,5%', value: 0.165 },
                { tipo: 'Residencial', Nome: 'Garantia Locatícia Residencial 17%', value: 0.17 },
                { tipo: 'Residencial', Nome: 'Garantia Locatícia Residencial 17,5%', value: 0.175 },
                { tipo: 'Residencial', Nome: 'Garantia Locatícia Residencial 18%', value: 0.18 },
                { tipo: 'Residencial', Nome: 'Garantia Locatícia Residencial 18,5%', value: 0.185 },
                { tipo: 'Residencial', Nome: 'Garantia Locatícia Residencial 19%', value: 0.19 },
                { tipo: 'Residencial', Nome: 'Garantia Locatícia Residencial 19,5%', value: 0.195 },
                { tipo: 'Residencial', Nome: 'Garantia Locatícia Residencial 20%', value: 0.20 },

                { tipo: 'Comercial', Nome: 'Garantia Locatícia Comercial 3%', value: 0.03 },
                { tipo: 'Comercial', Nome: 'Garantia Locatícia Comercial 4%', value: 0.04 },
                { tipo: 'Comercial', Nome: 'Garantia Locatícia Comercial 5%', value: 0.05 },
                { tipo: 'Comercial', Nome: 'Garantia Locatícia Comercial 6%', value: 0.06 },
                { tipo: 'Comercial', Nome: 'Garantia Locatícia Comercial 7%', value: 0.07 },
                { tipo: 'Comercial', Nome: 'Garantia Locatícia Comercial 8%', value: 0.08 },
                { tipo: 'Comercial', Nome: 'Garantia Locatícia Comercial 9%', value: 0.09 },
                { tipo: 'Comercial', Nome: 'Garantia Locatícia Comercial 9,5%', value: 0.095 },
                { tipo: 'Comercial', Nome: 'Garantia Locatícia Comercial 10%', value: 0.10 },
                { tipo: 'Comercial', Nome: 'Garantia Locatícia Comercial 10,5%', value: 0.105 },
                { tipo: 'Comercial', Nome: 'Garantia Locatícia Comercial 11%', value: 0.11 },
                { tipo: 'Comercial', Nome: 'Garantia Locatícia Comercial 11,5%', value: 0.115 },
                { tipo: 'Comercial', Nome: 'Garantia Locatícia Comercial 12%', value: 0.12 },
                { tipo: 'Comercial', Nome: 'Garantia Locatícia Comercial 12,5%', value: 0.125 },
                { tipo: 'Comercial', Nome: 'Garantia Locatícia Comercial 13%', value: 0.13 },
                { tipo: 'Comercial', Nome: 'Garantia Locatícia Comercial 13,5%', value: 0.135 },
                { tipo: 'Comercial', Nome: 'Garantia Locatícia Comercial 14%', value: 0.14 },
                { tipo: 'Comercial', Nome: 'Garantia Locatícia Comercial 14,5%', value: 0.145 },
                { tipo: 'Comercial', Nome: 'Garantia Locatícia Comercial 15%', value: 0.15 },
                { tipo: 'Comercial', Nome: 'Garantia Locatícia Comercial 15,5%', value: 0.155 },
                { tipo: 'Comercial', Nome: 'Garantia Locatícia Comercial 16%', value: 0.16 },
                { tipo: 'Comercial', Nome: 'Garantia Locatícia Comercial 16,5%', value: 0.165 },
                { tipo: 'Comercial', Nome: 'Garantia Locatícia Comercial 17%', value: 0.17 },
                { tipo: 'Comercial', Nome: 'Garantia Locatícia Comercial 17,5%', value: 0.175 },
                { tipo: 'Comercial', Nome: 'Garantia Locatícia Comercial 18%', value: 0.18 },
                { tipo: 'Comercial', Nome: 'Garantia Locatícia Comercial 18,5%', value: 0.185 },
                { tipo: 'Comercial', Nome: 'Garantia Locatícia Comercial 19%', value: 0.19 },
                { tipo: 'Comercial', Nome: 'Garantia Locatícia Comercial 19,5%', value: 0.195 },
                { tipo: 'Comercial', Nome: 'Garantia Locatícia Comercial 20%', value: 0.20 }
            ],
                    ListaProdutosTaxasFilter: [],
        ValorTotal: 0,
        //produtos
        DadosCompra: {
            imobiliaria: [],
            consumidor: [],
            garantidora: [],
            produtos: [],
            mensagem: [],
            agenda: [],
            foto: [],
            avulsos: [],
            informacao: [],
            pagamento: [],
            cupom: [],
            revisao: null,
        },
        linkPagamento: null,
        //pagamentos
        DadosGarantidora: [],
        DadosConfiguracao: [],
        isLoading: false,
        exibirFormulario: false,
        pedidoEmRevisaoId: null,
        pedidoEmRevisaoOriginal: null,
        enderecoEmRevisaoOriginal: null,
        itemEmRevisaoOriginal: null,
        PedidosAguardandoAnalise: [],
        headersPedidosAguardando: [
            { text: 'Id', value: 'pedId', sortable: true },
            { text: 'Data', value: 'pedDataPedido', sortable: true },
            { text: 'Tipo', value: 'tipoContratacao', sortable: false },
            { text: 'Garantidora / Imobiliária', value: 'entidadesResumo', sortable: false },
            { text: 'Cliente / Documento', value: 'clienteResumo', sortable: false },
            { text: 'Valor', value: 'pedValorTotalPedido', sortable: true },
            { text: 'Ações', value: 'actions', sortable: false }
        ],
        headersPedidosAguardandoExportacao: [
            { text: 'Id', value: 'pedId' },
            { text: 'Data', value: 'pedDataPedido' },
            { text: 'Tipo', value: 'tipoContratacao' },
            { text: 'Garantidora', value: 'garNome' },
            { text: 'Imobiliária', value: 'imobNome' },
            { text: 'Cliente', value: 'cliNome' },
            { text: 'Documento', value: 'cliDocumento' },
            { text: 'Valor', value: 'pedValorTotalPedido' }
        ],
        RetornoSerasaAntigo: null,
        ListaContratos: [],
        ContratoPedido: [],
        Assinatura: [],
        selectedSetup: null,
        obsAnalise: '',
        Qtdemultiplicador:null,
        ListQtdemultiplicador:[
              { nome: '3x', value: '3x' },
              { nome: '4x', value: '4x' },
              { nome: '5x', value: '5x' },
              { nome: '6x', value: '6x' },
              { nome: '7x', value: '7x' },
              { nome: '8x', value: '8x' },
              { nome: '9x', value: '9x' },
              { nome: '10x', value: '10x' },
              { nome: '11x', value: '11x' },
              { nome: '12x', value: '12x' },
              { nome: '14x', value: '14x' },
              { nome: '16x', value: '16x' },
              { nome: '18x', value: '18x' },
              { nome: '20x', value: '20x' },
              { nome: '22x', value: '22x' },
              { nome: '24x', value: '24x' },
              { nome: '26x', value: '26x' },
              { nome: '28x', value: '28x' },
              { nome: '30x', value: '30x' },
              { nome: '120x', value: '120x' }
        ],
        ListaConsultasCredito: [],
        ListaPlanosCobertura: [],
        CoberturaSelected:null,
        //subitpos
        tipoImovel: null,     // "Residencial" | "Comercial"
        residencialTipo: null, 
        tiposImoveis:[
        {
            id: "Residencial",
            subtipos: [
            { id: "Casa", nome: "Casa" },
            { id: "Apartamento", nome: "Apartamento" },
            { id: "Sobrado", nome: "Sobrado" },
            { id: "Kitnet", nome: "Kitnet" },
            { id: "Studio", nome: "Studio" },
            { id: "Chácara", nome: "Chácara" },
            { id: "Sítio", nome: "Sítio" },
            { id: "Terreno residencial", nome: "Terreno residencial" }
            ]
        },
        {
            id: "Comercial",
            subtipos: [
            { id: "Sala", nome: "Sala" },
            { id: "Sobrado", nome: "Sobrado" },
            { id: "Salão", nome: "Salão" },
            { id: "Loja", nome: "Loja" },
            { id: "Galpão", nome: "Galpão" },
            { id: "Depósito", nome: "Depósito" },
            { id: "Prédio", nome: "Prédio" },
            { id: "Conjunto", nome: "Conjunto" },
            { id: "Ponto", nome: "Ponto" },
            { id: "Terreno comercial", nome: "Terreno comercial" }
            ]
        }
        ],
    }),
    methods: {
        async IniciarNovaContratacao() {
            await this.LimparMemoria(0);
            this.etapaAtual = 1;
            this.exibirFormulario = true;
            window.scrollTo({ top: 0, behavior: 'smooth' });
        },
        async CancelarFormulario() {
            const confirmacao = await this.$mensagemConfirma(
                'Os dados preenchidos nesta edição serão descartados e você voltará para a lista de contratações aguardando envio.',
                {
                    title: 'Cancelar preenchimento?',
                    confirmButtonText: 'Descartar e voltar',
                    cancelButtonText: 'Continuar editando'
                }
            );
            if (!confirmacao?.isConfirmed) return;
            await this.LimparMemoria(0);
        },
        async CarregarPedidosAguardandoAnalise() {
            const { data } = await axios.get('/Telas/ContratacaoGarantia/GetPedidosAguardandoAnalise');
            const garantidoras = data.garantidoras || [];
            const nomesGarantidoras = new Map(garantidoras.map(item => [String(item.garId), item.garNomeEmpresa]));
            this.PedidosAguardandoAnalise = (data.pedidos || [])
                .filter(item => Number(item.pspId) === 1)
                .map(item => ({
                    ...item,
                    garNome: nomesGarantidoras.get(String(item.garId)) || '',
                    tipoContratacao: Number(item.pedCiclo) > 1 ? `Renovação - ciclo ${item.pedCiclo}` : 'Inicial'
                }))
                .sort((a, b) => Number(b.pedId) - Number(a.pedId));
        },
        async RevisarPedido(item) {
            const confirmacao = await this.$mensagemConfirma(
                `Carregar a contratação ${item.pedId} para revisão? Os dados atualmente preenchidos na tela serão substituídos.`,
                {
                    title: 'Revisar dados da contratação?',
                    confirmButtonText: 'Carregar para revisão',
                    cancelButtonText: 'Cancelar'
                }
            );
            if (!confirmacao?.isConfirmed) return;

            this.startLoading();
            try {
                localStorage.removeItem(this.$DadosCompraManual);
                const { data } = await axios.get(`/Telas/ContratacaoGarantia/GetPedidoAguardandoRevisao/${item.pedId}`);
                const pedidoItem = Array.isArray(data.itens) ? data.itens[0] : null;
                if (!pedidoItem || !data.endereco) throw new Error('A contratação não possui garantia ou endereço para revisão.');

                this.pedidoEmRevisaoId = Number(data.pedido.pedId);
                this.pedidoEmRevisaoOriginal = data.pedido;
                this.enderecoEmRevisaoOriginal = data.endereco;
                this.itemEmRevisaoOriginal = pedidoItem;

                this.selectedGarantidora = data.garantidora;
                await this.BuscaImobialiarias();
                this.selectedImobiliaria = this.ListImobiliarias.find(x => Number(x.imoId) === Number(data.imobiliaria.imoId)) || {
                    ...data.imobiliaria,
                    nomeConcatenado: `${data.imobiliaria.imoId} - ${data.imobiliaria.imoNomeEmpresa} - ${data.imobiliaria.imoDocumento}`
                };
                await this.SelecionarConsumidor();
                this.selectedConsumidor = this.ListConsumidor.find(x => Number(x.cliId) === Number(data.cliente.cliId)) || data.cliente;
                this.liberaEndGarantia = true;

                const endereco = data.endereco;
                this.tipoImovel = endereco.pdcTipo;
                this.residencialTipo = endereco.pdcResidencialTipo || '';
                this.endereco = endereco.pdcEndereco;
                this.numeroend = endereco.pdcNumero;
                this.complemento = endereco.pdcComplemento || '';
                this.numCep = endereco.pdcCep;
                this.siglaEstado = endereco.pdcEstado;
                this.nomeCidade = endereco.pdcCidade;
                this.nomeBairro = endereco.pdcBairro;
                this.showend = true;

                const produtoBase = this.ListProdutosGeral.find(x => Number(x.proProdutos?.proId) === Number(pedidoItem.proId));
                const { data: camposProduto } = await axios.get(`/Telas/ContratacaoGarantia/GetAllByProIdItens/${pedidoItem.proId}`);
                const adicionais = Array.isArray(data.adicionais) ? data.adicionais : [];
                const grids = (camposProduto || []).map(campo => {
                    const adicional = adicionais.find(x => String(x.piaNomeProduto).toLocaleLowerCase() === String(campo.pisNome).toLocaleLowerCase());
                    return { ...campo, piaId: adicional?.piaId || 0, pisCampoExtra1: adicional?.piaValorProduto ?? 0 };
                });
                const wrapperProduto = produtoBase ? { ...produtoBase, proProdutos: { ...produtoBase.proProdutos } } : { proProdutos: { ...(pedidoItem.proProdutos || {}), proId: pedidoItem.proId, proNomeProduto: pedidoItem.pdiNomeProduto } };
                wrapperProduto.proProdutos.proProdutosGrids = grids;
                wrapperProduto.qtdeProduto = pedidoItem.pdiQtdeProduto;
                wrapperProduto.valorProduto = Number(pedidoItem.pdiValorProduto || 0);
                wrapperProduto.valorTotalProduto = Number(pedidoItem.pdiValorTotalProduto || 0);
                wrapperProduto.codSetup = pedidoItem.pdiCampoExtra1 || '0';
                wrapperProduto.taxa = Number(pedidoItem.pdiCampoExtra2 || 0);
                wrapperProduto.tipoCalculoTaxa = 'taxa';
                wrapperProduto.vigenciaini = pedidoItem.pdiDataVigenciaIni;
                wrapperProduto.vigenciafim = pedidoItem.pdiDataVigenciaFim;
                this.ProdutoSelected = wrapperProduto;
                this.ProdutosGrid = grids;
                this.ListaPedidoItem = [wrapperProduto];
                this.PlanosGarantiasSelected = wrapperProduto.codSetup;
                this.ProdutosTaxas = wrapperProduto.taxa;
                this.DataInicioVigenciaGarantia = moment(wrapperProduto.vigenciaini).format('YYYY-MM-DD');
                this.DataFimVigenciaGarantia = moment(wrapperProduto.vigenciafim).format('YYYY-MM-DD');

                const { data: planos } = await axios.get(`/Telas/ContratacaoGarantia/GetPlanosCoberturaByImoId/${data.imobiliaria.imoId}`);
                this.ListaPlanosCobertura = planos || [];
                this.CoberturaSelected = this.ListaPlanosCobertura.find(x =>
                    x.ipcTipoCobertura === this.tipoImovel && Math.abs(Number(x.ipcPercentualGarantia) - wrapperProduto.taxa) < 0.000001
                ) || null;
                this.Qtdemultiplicador = this.CoberturaSelected ? `${this.CoberturaSelected.ipcCobertura}x` : null;
                wrapperProduto.cobertura = this.Qtdemultiplicador;
                wrapperProduto.coberturaId = this.CoberturaSelected?.ipcId || null;

                const { data: formas } = await axios.get('/Telas/ContratacaoGarantia/GetAllFormasPgto');
                this.ListaFormasPagamento = (formas || []).filter(x => x.cfpVisivel);
                const formaParcelasId = data.pedido.pedTipoPgtoParcelas || data.pedido.pedTipoPgto;
                const formaEntradaId = data.pedido.pedTipoPgtoEntrada;
                const linkPagamento = String(data.pedido.pedTipoPgto || '') === '5';
                const setup = Number(wrapperProduto.codSetup || 0);
                const entradaTotal = Number(data.pedido.pedValorEntrada || 0);
                this.pagamentoFlexivel = {
                    linkPagamento,
                    possuiEntrada: linkPagamento ? false : data.pedido.pedPossuiEntrada === true,
                    valorEntrada: linkPagamento ? '' : Math.max(0, entradaTotal - (data.pedido.pedSetupEntrada ? setup : 0)),
                    setupNaEntrada: linkPagamento ? false : data.pedido.pedSetupEntrada === true,
                    quantidadeParcelas: linkPagamento ? 0 : Number(data.pedido.pedQtdeParcelas || 1),
                    formaEntrada: linkPagamento ? null : (this.ListaFormasPagamento.find(x => String(x.cfpId) === String(formaEntradaId)) || null),
                    formaParcelas: linkPagamento ? null : (this.ListaFormasPagamento.find(x => String(x.cfpId) === String(formaParcelasId)) || null)
                };
                this.selectedFormaPagamento = linkPagamento ? { cfpId: 5, cfpNome: 'Link de Pagamento' } : this.pagamentoFlexivel.formaParcelas;
                this.calculatotal();
                this.etapaAtual = 1;
                this.SalvarMemoria(2);
                this.exibirFormulario = true;
                window.scrollTo({ top: 0, behavior: 'smooth' });
                this.$mensagemAvisoSucesso(`Contratação ${item.pedId} carregada para revisão.`);
            } catch (error) {
                this.pedidoEmRevisaoId = null;
                this.$mensagemErro(error?.response?.data?.message || error?.response?.data?.Message || error?.message || 'Não foi possível carregar a contratação para revisão.');
            } finally {
                this.stopLoading();
            }
        },
        async EnviarPedidoAnalise(item) {
            const confirmacao = await this.$mensagemConfirma(`Enviar a contratação ${item.pedId} para análise de crédito?`);
            if (!confirmacao?.isConfirmed) return;
            const documento = String(item.cliDocumento || '').replace(/\D/g, '');
            if (!documento) {
                this.$mensagemAviso('O cliente da contratação não possui documento válido para análise.');
                return;
            }
            try {
                await axios.post('/Telas/ContratacaoGarantia/CheckAnaliseCredito', {
                    pedId: item.pedId,
                    documentoList: [documento],
                    fonteList: ['cdl', 'jus'],
                    validarRegra: true,
                    fazerAnalise: 1,
                    garId: item.garId,
                    imoId: item.imobId,
                    cliId: item.cliId
                });
                this.$mensagemAvisoSucesso('Contratação encaminhada para análise.');
                await this.CarregarPedidosAguardandoAnalise();
            } catch (error) {
                this.$mensagemErro(error?.response?.data?.message || error?.response?.data?.Message || error?.message || 'Não foi possível enviar a contratação para análise.');
            }
        },
        async EnviarPedidoSemAnalise(item) {
            const confirmacao = await this.$mensagemConfirma(`Enviar a contratação ${item.pedId} sem análise automática?`);
            if (!confirmacao?.isConfirmed) return;
            try {
                await axios.post('/Telas/ContratacaoGarantia/CheckAnaliseCredito', {
                    pedId: item.pedId,
                    documentoList: [],
                    fonteList: [],
                    validarRegra: false,
                    fazerAnalise: 0,
                    garId: item.garId,
                    imoId: item.imobId,
                    cliId: item.cliId
                });
                this.$mensagemAvisoSucesso('Contratação encaminhada sem análise automática.');
                await this.CarregarPedidosAguardandoAnalise();
            } catch (error) {
                this.$mensagemErro(error?.response?.data?.message || error?.response?.data?.Message || error?.message || 'Não foi possível encaminhar a contratação.');
            }
        },
        async CancelarPedidoAguardando(item) {
            const confirmacao = await this.$mensagemConfirma(`Cancelar a contratação ${item.pedId}?`);
            if (!confirmacao?.isConfirmed) return;
            try {
                await axios.put(`/Telas/ContratacaoGarantia/CancelarAguardandoAnalise/${item.pedId}`);
                this.$mensagemAvisoSucesso('Contratação cancelada.');
                await this.CarregarPedidosAguardandoAnalise();
            } catch (error) {
                this.$mensagemErro(error?.response?.data?.message || error?.response?.data?.Message || error?.message || 'Não foi possível cancelar a contratação.');
            }
        },
        formatarMoeda(valor) {
            return Number(valor || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        },
        AoAlterarEntrada() {
            if (!this.pagamentoFlexivel.possuiEntrada) {
                this.pagamentoFlexivel.valorEntrada = '';
                if (!this.pagamentoFlexivel.setupNaEntrada) this.pagamentoFlexivel.formaEntrada = null;
            }
            this.SalvarMemoria(2);
        },
        AoAlterarLinkPagamento() {
            if (this.pagamentoFlexivel.linkPagamento) {
                this.pagamentoFlexivel.possuiEntrada = false;
                this.pagamentoFlexivel.valorEntrada = '';
                this.pagamentoFlexivel.setupNaEntrada = false;
                this.pagamentoFlexivel.formaEntrada = null;
                this.pagamentoFlexivel.formaParcelas = null;
                this.selectedFormaPagamento = { cfpId: 5, cfpNome: 'Link de Pagamento' };
            } else if (String(this.selectedFormaPagamento?.cfpId) === '5') {
                this.selectedFormaPagamento = null;
            }
            this.SalvarMemoria(2);
        },
        NormalizarEntrada() {
            const valor = this.parseValorDecimal(this.pagamentoFlexivel.valorEntrada);
            if (valor > this.ValorGarantiaSemSetup) {
                this.pagamentoFlexivel.valorEntrada = this.ValorGarantiaSemSetup.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            }
            this.SalvarMemoria(2);
        },
        LimitarParcelas() {
            const quantidade = Math.trunc(Number(this.pagamentoFlexivel.quantidadeParcelas) || 1);
            this.pagamentoFlexivel.quantidadeParcelas = Math.min(12, Math.max(1, quantidade));
            this.SalvarMemoria(2);
        },
        AbrirCadastroClienteRapido() {
            if (!this.selectedGarantidora || !this.selectedImobiliaria) {
                this.$mensagemAviso('Selecione garantidora e imobiliária antes de cadastrar o cliente.');
                return;
            }
            this.clienteRapido = { tpdId: 1, cliNomeEmpresa: '', cliDocumento: '', cliTelefone: '', cliWhatsapp: '', cliEmail: '', cliDataNascimento: '', cliEstadoCivil: null, cliNomeMae: '', cliNomePai: '', cliResponsavel: '', cliCampoExtra1: '' };
            this.clienteRapidoEndereco = { cleEndereco: '', cleNumero: '', cleComplemento: '', cleCep: '', clePais: 'Brasil', cleEstado: '', cleCidade: '', cleBairro: '', cleObsEndereco: '' };
            this.usarEnderecoClienteNaContratacao = false;
            this.dialogClienteRapido = true;
        },
        async BuscarCepClienteRapido() {
            const cep = String(this.clienteRapidoEndereco.cleCep || '').replace(/\D/g, '');
            if (cep.length !== 8) {
                this.$mensagemAviso('Informe um CEP válido.');
                return;
            }
            try {
                const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
                const data = await response.json();
                if (data.erro) throw new Error('CEP não encontrado.');
                this.clienteRapidoEndereco.cleEndereco = data.logradouro || '';
                this.clienteRapidoEndereco.cleBairro = data.bairro || '';
                this.clienteRapidoEndereco.cleCidade = data.localidade || '';
                this.clienteRapidoEndereco.cleEstado = data.uf || '';
            } catch (error) {
                this.$mensagemErro(error?.message || 'Não foi possível consultar o CEP.');
            }
        },
        ValidarClienteRapido() {
            const c = this.clienteRapido;
            const e = this.clienteRapidoEndereco;
            if (!c.cliNomeEmpresa || !c.cliDocumento || !c.cliTelefone || !c.cliWhatsapp || !c.cliEmail) return 'Preencha nome, documento, telefone, WhatsApp e e-mail.';
            if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(c.cliEmail)) return 'Informe um e-mail válido.';
            const documento = String(c.cliDocumento).replace(/\D/g, '');
            if (c.tpdId === 1 && documento.length !== 11) return 'Informe um CPF válido com 11 dígitos.';
            if (c.tpdId === 2 && String(c.cliDocumento).replace(/[^a-zA-Z0-9]/g, '').length !== 14) return 'Informe um CNPJ válido com 14 caracteres.';
            if (c.tpdId === 1 && (!c.cliDataNascimento || !c.cliEstadoCivil || !c.cliNomeMae || !c.cliNomePai)) return 'Preencha nascimento, estado civil e filiação.';
            if (c.tpdId === 2 && (!c.cliResponsavel || !c.cliCampoExtra1)) return 'Preencha responsável e CPF do responsável.';
            if (!e.cleCep || !e.cleEndereco || !e.cleNumero || !e.cleBairro || !e.cleCidade || !e.cleEstado) return 'Preencha o endereço cadastral completo.';
            return null;
        },
        async SalvarClienteRapido() {
            if (this.salvandoClienteRapido) return;
            const erro = this.ValidarClienteRapido();
            if (erro) {
                this.$mensagemAviso(erro);
                return;
            }
            this.salvandoClienteRapido = true;
            try {
                const response = await axios.post('/Telas/ContratacaoGarantia/AddClienteRapido', {
                    cliente: {
                        ...this.clienteRapido,
                        cliId: 0,
                        garId: this.selectedGarantidora.garId,
                        imoId: this.selectedImobiliaria.imoId,
                        cliRazaoSocial: this.clienteRapido.tpdId === 2 ? this.clienteRapido.cliNomeEmpresa : '',
                        cliAtivo: true,
                        cliVisivel: true,
                        cliDataNascimento: this.clienteRapido.tpdId === 1 ? this.clienteRapido.cliDataNascimento : null
                    },
                    endereco: { ...this.clienteRapidoEndereco, cleId: 0, grtId: 0, cdtId: 0 }
                });
                const novoCliente = response.data;
                novoCliente.nomeConcatenado = `${novoCliente.cliId} - ${novoCliente.cliNomeEmpresa} - ${novoCliente.cliDocumento}`;
                this.ListConsumidor = [...this.ListConsumidor, novoCliente].sort((a, b) => a.cliNomeEmpresa.localeCompare(b.cliNomeEmpresa, 'pt', { sensitivity: 'base' }));
                this.selectedConsumidor = novoCliente;
                if (this.usarEnderecoClienteNaContratacao) {
                    this.endereco = this.clienteRapidoEndereco.cleEndereco;
                    this.numeroend = this.clienteRapidoEndereco.cleNumero;
                    this.complemento = this.clienteRapidoEndereco.cleComplemento;
                    this.numCep = this.clienteRapidoEndereco.cleCep;
                    this.siglaEstado = String(this.clienteRapidoEndereco.cleEstado || '').toUpperCase();
                    this.nomeCidade = this.clienteRapidoEndereco.cleCidade;
                    this.nomeBairro = this.clienteRapidoEndereco.cleBairro;
                    this.showend = true;
                }
                this.dialogClienteRapido = false;
                await this.ValidaConsumidor();
                this.$mensagemAvisoSucesso('Cliente cadastrado e selecionado.');
            } catch (error) {
                const mensagem = error?.response?.data?.message || error?.response?.data?.Message || error?.message || 'Não foi possível cadastrar o cliente.';
                this.$mensagemErro(mensagem);
            } finally {
                this.salvandoClienteRapido = false;
            }
        },
        ValidarEtapa(etapa) {
            if (etapa === 1) {
                if (!this.selectedGarantidora) return 'Selecione a garantidora.';
                if (!this.selectedImobiliaria) return 'Selecione a imobiliária.';
                if (!this.selectedConsumidor) return 'Selecione o cliente.';
            }
            if (etapa === 2) {
                if (!this.endereco || !this.numeroend || !this.numCep || !this.nomeBairro || !this.nomeCidade || !this.siglaEstado) return 'Preencha o endereço completo do imóvel.';
                if (!this.tipoImovel) return 'Selecione o tipo do imóvel.';
                if (this.tipoImovel === 'Residencial' && !this.residencialTipo) return 'Selecione o tipo do imóvel residencial.';
            }
            if (etapa === 3 && (!this.ListaPedidoItem || this.ListaPedidoItem.length === 0)) return 'Adicione a garantia da contratação.';
            if (etapa === 4) {
                if (this.pagamentoFlexivel.linkPagamento) return null;
                this.LimitarParcelas();
                if (this.pagamentoFlexivel.possuiEntrada && this.ValorEntradaGarantia <= 0) return 'Informe um valor de entrada maior que zero.';
                if (this.ValorEntradaGarantia >= this.ValorGarantiaSemSetup && this.SaldoPagamentoFlexivel <= 0) return 'A entrada deve deixar saldo para pelo menos uma parcela.';
                if (this.ValorTotalEntrada > 0 && !this.pagamentoFlexivel.formaEntrada) return 'Selecione a forma de pagamento da entrada.';
                if (!this.pagamentoFlexivel.formaParcelas) return 'Selecione a forma de pagamento das parcelas.';
                if (this.SaldoPagamentoFlexivel <= 0) return 'O saldo parcelado deve ser maior que zero.';
            }
            return null;
        },
        ProximaEtapa() {
            const erro = this.ValidarEtapa(this.etapaAtual);
            if (erro) {
                this.$mensagemAviso(erro);
                return;
            }
            this.SalvarMemoria(2);
            this.etapaAtual = Math.min(5, this.etapaAtual + 1);
            window.scrollTo({ top: 0, behavior: 'smooth' });
        },
        VoltarEtapa() {
            this.SalvarMemoria(2);
            this.etapaAtual = Math.max(1, this.etapaAtual - 1);
            window.scrollTo({ top: 0, behavior: 'smooth' });
        },
        IrParaEtapa(destino) {
            if (destino <= this.etapaAtual) {
                this.etapaAtual = destino;
                return;
            }
            for (let etapa = this.etapaAtual; etapa < destino; etapa++) {
                const erro = this.ValidarEtapa(etapa);
                if (erro) {
                    this.$mensagemAviso(erro);
                    return;
                }
            }
            this.etapaAtual = destino;
        },
        startLoading() {
            this.isLoading = true;
        },
        stopLoading() {
            this.isLoading = false;
        },
        TituloImobiliaria(item) {
            const registro = item?.raw || item || {};
            return [registro.imoId, registro.imoNomeEmpresa, registro.imoDocumento].filter(valor => valor != null && valor !== '').join(' - ');
        },
        TituloCliente(item) {
            const registro = item?.raw || item || {};
            return [registro.cliId, registro.cliNomeEmpresa, registro.cliDocumento].filter(valor => valor != null && valor !== '').join(' - ');
        },
        //garantidoras
        async BuscaImobialiarias() {
            if (this.selectedGarantidora != '' && this.selectedGarantidora != null) {
                this.selectedImobiliaria = null;
                this.ListImobiliariaGeral = [];
                this.liberaEndGarantia = false;
                this.ResetDatasVigenciaGarantia();
                let _validaGar = await this.ValidaDadosGarantidora(this.selectedGarantidora.garId);
                if (_validaGar) {
                    await axios.get(`/Telas/ContratacaoGarantia/GetByGarIdParIdImobiliaria/` + this.selectedGarantidora.garId + '/0')
                        .then(response => {
                            this.ListImobiliariaGeral = response.data;
                            this.ListImobiliarias = this.ListImobiliariaGeral.filter(x => x.imoVisivel).sort((a, b) =>
                        a.imoNomeEmpresa.localeCompare(
                        b.imoNomeEmpresa,
                        'pt',
                        { sensitivity: 'base' }
                        )
                    );
                            this.ListImobiliarias = this.ListImobiliarias.map(item => {
                                return {
                                    ...item,
                                    nomeConcatenado: `${item.imoId} - ${item.imoNomeEmpresa} - ${item.imoDocumento}`
                                };
                            });

                            if (this.User.tpeid == 3) {
                                this.ListImobiliarias = this.ListImobiliarias.filter(x => x.imoId == this.User.pesid)
                                this.selectedImobiliaria = this.ListImobiliarias[0];
                                this.SelecionarConsumidor();
                            }
                        });

                           await axios.get('/Telas/ContratacaoGarantia/GetByGarIdGarantidoraPagamento/' + this.selectedGarantidora.garId)
                            .then(response => {
                                this.DadosPagamento = response.data;
                                //console.log('this.DadosPagamento')
                                //console.log(this.DadosPagamento)

                                  axios.get(`/Telas/ContratacaoGarantia/GetAllFormasPgto`)
                                        .then(response => {
                                            if (this.DadosPagamento.length > 0 && this.DadosPagamento[0].topId != 2){
                                              this.ListaFormasPagamento = response.data.filter(x=> x.cfpVisivel);
                                            }
                                            else{
                                                this.ListaFormasPagamento = response.data.filter(x=> x.cfpVisivel && x.topId == 2);
                                            }
                                            //console.log('ListaFormasPagamento')
                                            //console.log(this.ListaFormasPagamento)
                                        });
                            })
                            .catch(error => {
                                console.error(error);
                            });

                }
            }
        },
        //consumidor
        async SelecionarConsumidor() {
            if (this.selectedImobiliaria != '' && this.selectedImobiliaria != null) {
                this.ListConsumidor = [];
                this.selectedConsumidor = null;
                this.liberaEndGarantia = false;
                let valido = await this.ValidaDadosImobiliaria(this.selectedImobiliaria.imoId);
                if (valido) {
                    const response = await axios.get(`/Telas/ContratacaoGarantia/GetByGarIdImoIdClientes/0/` + this.selectedImobiliaria.imoId);
                    this.ListConsumidor = response.data.filter(x => x.cliAtivo).sort((a, b) =>
                        a.cliNomeEmpresa.localeCompare(b.cliNomeEmpresa, 'pt', { sensitivity: 'base' })
                    );
                }
            }
            // console.log('Produto Adicional Selecionado:', this.selectedImobiliaria);
        },
        async ValidaConsumidor() {
            if (!this.selectedConsumidor || !this.selectedConsumidor.cliId) {
                this.ListaConsultasCredito = [];
                this.liberaEndGarantia = false;
                return;
            }
            let valido = await this.ValidaDadosCliente(this.selectedConsumidor.cliId);
                if (valido) {
                       this.ListaConsultasCredito = [];
                       await axios.get(`/Telas/ContratacaoGarantia/GetBycliIdClientesConsultas/` + this.selectedConsumidor.cliId)
                        .then(response => {
                            if (response.data.length > 0) {
                                this.ListaConsultasCredito = response.data;
                            }
                            else {
                                this.ListaConsultasCredito = [];
                            }
                        });

                      this.liberaEndGarantia = true;
                }
                else{
                    this.liberaEndGarantia = false;
                }
                      
        },
        //consumidor
        //endereco
        Buscacep(value) {
            if (this.numCep != '') {
                fetch("https://viacep.com.br/ws/" + value + "/json/")
                    .then(response => {
                        if (!response.ok) {
                            this.$mensagemAviso("CEP inexistente");
                            throw new Error("CEP inexistente");
                        }
                        return response.json();
                    })
                    .then(data => {
                        this.Retornocep = data;
                        if (this.Retornocep != null) {
                            this.endereco = this.Retornocep.logradouro;
                            this.numeroend = null;
                            this.complemento = null;
                            this.siglaEstado = this.Retornocep.uf;
                            this.nomeCidade = this.Retornocep.localidade;
                            this.nomeBairro = this.Retornocep.bairro;
                            this.showend = true;
                        } else {
                            this.$mensagemAviso("CEP inexistente");
                        }
                    })
                    .catch(error => {
                        console.error(error);
                    });
            }
            else {
                this.$mensagemAviso("Digite um cep válido");
            }

        },
        ValidaEndereco() {
            if (this.numCep == '' || this.numCep == null) {
                this.$mensagemAviso("Preencha o CEP");
            }
            else if (this.endereco == '' || this.endereco == null) {
                this.$mensagemAviso("Preencha o Endereço");
            }
            else if (this.numeroend == '' || this.numeroend == null) {
                this.$mensagemAviso("Preencha o número do endereço");
            }
            else if (this.siglaEstado == '' || this.siglaEstado == null) {
                this.$mensagemAviso("Preencha sigla do estado");
            }
            else if (this.nomeCidade == '' || this.nomeCidade == null) {
                this.$mensagemAviso("Preencha nome da cidade");
            }
            else if (this.nomeBairro == '' || this.nomeBairro == null) {
                this.$mensagemAviso("Preencha nome do bairro");
            }
            else if (this.tipoImovel == '' || this.tipoImovel == null) {
                this.$mensagemAviso("Selecione tipo de imóvel");
            }
            else if (this.tipoImovel == 'Residencial' && (this.residencialTipo == null || this.residencialTipo == '')) {
                this.$mensagemAviso("Preencha tipo de imóvel residencial no endereço.")
            }
            else {
                this.dialogEndereco = false;
                this.ListaPedidoItem = [];
                this.SalvarMemoria(2);
                this.ListProdutos = this.ListProdutosGeral.filter(x =>
                    x.proProdutos.proNomeProduto && this.tipoImovel &&
                    x.proProdutos.proNomeProduto.toLowerCase().includes(this.tipoImovel.toLowerCase())
                );
                this.ListaProdutosTaxasFilter = this.ListaProdutosTaxas.filter(x => x.tipo === this.tipoImovel);
                 console.log(' this.ListProdutos')
                 console.log( this.ListProdutos)
            }
        },
        //endereco
        //pedido
        LimparEndereco(){
            this.endereco = "";
            this.numeroend = "";
            this.complemento = "";
            this.siglaEstado = "";
            this.nomeCidade = "";
            this.nomeBairro = "";
            this.numCep = "";
            this.showend = false,
            this.tipoImovel = "";
            this.residencialTipo = "";           
            this.dialogEndereco = false;
            if (this.selectedConsumidor.cliId != null && this.selectedConsumidor.cliId!=''){
                this.liberaEndGarantia = true;
            }
            else{
                this.liberaEndGarantia = false;
            }
        },
        async LimparMemoria(value) {
            localStorage.removeItem(this.$DadosCompraManual);
            this.etapaAtual = 1;
            this.exibirFormulario = false;
            this.pedidoEmRevisaoId = null;
            this.pedidoEmRevisaoOriginal = null;
            this.enderecoEmRevisaoOriginal = null;
            this.itemEmRevisaoOriginal = null;
            if (value == 1) {
                this.$mensagemAviso("Memória Limpa.");
            }

            this.vshow = false;
            this.selectedImobiliaria = null;
            this.selectedConsumidor = null;
            this.ProdutoSelected = "";
            this.ListaPedidoItem = [];
            this.endereco = "";
            this.numeroend = "";
            this.complemento = "";
            this.siglaEstado = "";
            this.nomeCidade = "";
            this.nomeBairro = "";
            this.numCep = "";
            this.showend = false,
            this.tipoImovel = "";
            this.residencialTipo = "";
            this.TotalPedido = '';
            this.liberaEndGarantia = false;
            this.selectedFormaPagamento = null;
            this.selectedSetup = null;
            this.pagamentoFlexivel = { linkPagamento: false, possuiEntrada: false, valorEntrada: '', setupNaEntrada: false, quantidadeParcelas: 12, formaEntrada: null, formaParcelas: null };
            this.ResetDatasVigenciaGarantia();
            await this.Get();
        },
        SalvarMemoria(value) {
            localStorage.removeItem(this.$DadosCompraManual);
            this.DadosCompra.imobiliaria = [];
            this.DadosCompra.consumidor = [];
            this.DadosCompra.garantidora = [];
            this.DadosCompra.produtos = [];
            this.DadosCompra.mensagem = [];
            this.DadosCompra.agenda = [];
            this.DadosCompra.foto = [];
            this.DadosCompra.avulsos = [];
            this.DadosCompra.informacao = [];
            this.DadosCompra.pagamento = [];
            this.DadosCompra.cupom = [];
            this.DadosCompra.revisao = this.pedidoEmRevisaoId != null ? {
                pedId: this.pedidoEmRevisaoId,
                pedido: this.pedidoEmRevisaoOriginal,
                endereco: this.enderecoEmRevisaoOriginal,
                pedidoItem: this.itemEmRevisaoOriginal
            } : null;

            //garantidora
            this.DadosCompra.garantidora.push(this.selectedGarantidora);

            //imobiliaria
            this.DadosCompra.imobiliaria.push(this.selectedImobiliaria);

            //consumidor
            this.DadosCompra.consumidor.push(this.selectedConsumidor);

            //entrega
            let _agenda = {
                tipoImovel: this.tipoImovel,
                estado: this.siglaEstado,
                cidade: this.nomeCidade,
                bairro: this.nomeBairro,
                endereco: this.endereco,
                numero: this.numeroend,
                complemento: this.complemento,
                cep: this.numCep,
                residencialTipo: this.residencialTipo === null ? '' : this.residencialTipo,
            }

            this.DadosCompra.agenda.push(_agenda);


            //produto
            if (this.ListaPedidoItem.length > 0) {
                this.DadosCompra.produtos.push(this.ListaPedidoItem);
            }

             //pagamento
            const formaPagamentoAtual = this.pagamentoFlexivel.linkPagamento
                ? { cfpId: 5, cfpNome: 'Link de Pagamento' }
                : this.pagamentoFlexivel.formaParcelas;
            if (formaPagamentoAtual != null) {
                this.selectedFormaPagamento = formaPagamentoAtual;
                this.DadosCompra.pagamento.push(formaPagamentoAtual);
            }
            this.DadosCompra.informacao.push({
                SetupEntrada: this.pagamentoFlexivel.setupNaEntrada,
                PagamentoFlexivel: {
                    linkPagamento: this.pagamentoFlexivel.linkPagamento === true,
                    possuiEntrada: this.pagamentoFlexivel.linkPagamento ? false : this.pagamentoFlexivel.possuiEntrada,
                    valorEntrada: this.pagamentoFlexivel.linkPagamento ? '' : this.pagamentoFlexivel.valorEntrada,
                    valorTotalEntrada: this.pagamentoFlexivel.linkPagamento ? 0 : this.ValorTotalEntrada,
                    setupNaEntrada: this.pagamentoFlexivel.linkPagamento ? false : this.pagamentoFlexivel.setupNaEntrada,
                    quantidadeParcelas: this.pagamentoFlexivel.linkPagamento ? 0 : this.pagamentoFlexivel.quantidadeParcelas,
                    valorParcela: this.pagamentoFlexivel.linkPagamento ? 0 : this.ValorParcelaFlexivel,
                    formaEntrada: this.pagamentoFlexivel.linkPagamento ? null : this.pagamentoFlexivel.formaEntrada,
                    formaParcelas: this.pagamentoFlexivel.linkPagamento ? null : this.pagamentoFlexivel.formaParcelas
                }
            });
            this.DadosCompra.avulsos.push({
                QtdeMultiplicador: this.Qtdemultiplicador,
                CoberturaId: this.CoberturaSelected?.ipcId ?? null
            })


            localStorage.setItem(this.$DadosCompraManual, JSON.stringify(this.DadosCompra));
            if (value == 1) {
                this.$mensagemAviso("Salvo em memória.")
            }

        },
        AvisoSemAnalise() {
            this.$mensagemConfirma('Essa garantia não passará por uma avaliação criteriosa de crédito e jurídica, sendo de responsabilidade da garantidora esse risco')
            .then((result) => {
            if (result.isConfirmed) {
                // Lógica para excluir o item
               this.GerarPedido(0);
            }
            });
        },
        async SalvarContratacao() {
            const erro = this.ValidarEtapa(5);
            if (erro) {
                this.$mensagemAviso(erro);
                return;
            }

            const emRevisao = this.pedidoEmRevisaoId != null;
            const confirmacao = await this.$mensagemConfirma(
                emRevisao
                    ? 'As alterações serão salvas e a contratação continuará aguardando uma ação de envio. Ela não seguirá automaticamente para análise.'
                    : 'A contratação será salva como “Aguardando envio” e ainda não seguirá para análise. Depois de revisar os dados, será necessário clicar em “Enviar para análise” ou “Enviar sem análise”.',
                {
                    title: emRevisao ? 'Alterar contratação?' : 'Salvar contratação para revisão?',
                    confirmButtonText: emRevisao ? 'Alterar contratação' : 'Salvar e revisar depois',
                    cancelButtonText: 'Voltar e continuar editando'
                }
            );

            if (!confirmacao?.isConfirmed) return;
            if (emRevisao) await this.AlterarContratacaoAguardando();
            else await this.GerarPedido(null);
        },
        async AlterarContratacaoAguardando() {
            this.startLoading();
            try {
                const itemTela = this.ListaPedidoItem[0];
                const linkPagamento = this.pagamentoFlexivel.linkPagamento === true;
                const formaParcelas = this.pagamentoFlexivel.formaParcelas;
                const formaEntrada = this.pagamentoFlexivel.formaEntrada;
                const pedido = {
                    ...this.pedidoEmRevisaoOriginal,
                    pedId: this.pedidoEmRevisaoId,
                    cliId: this.selectedConsumidor.cliId,
                    imobId: this.selectedImobiliaria.imoId,
                    garId: this.selectedGarantidora.garId,
                    pspId: 1,
                    pedFormaPgto: linkPagamento ? 'Link de Pagamento' : (formaParcelas?.cfpNome || ''),
                    pedTipoPgto: linkPagamento ? '5' : (formaParcelas?.cfpId != null ? String(formaParcelas.cfpId) : ''),
                    pedValorParcelas: linkPagamento ? 0 : this.ValorParcelaFlexivel,
                    pedQtdeParcelas: linkPagamento ? 0 : Number(this.pagamentoFlexivel.quantidadeParcelas || 1),
                    pedValorEntrada: linkPagamento ? 0 : this.ValorTotalEntrada,
                    pedValorTotalPedido: Number(this.TotalPedido || 0),
                    pedSetupEntrada: linkPagamento ? false : this.pagamentoFlexivel.setupNaEntrada === true,
                    pedPossuiEntrada: linkPagamento ? false : this.pagamentoFlexivel.possuiEntrada === true,
                    pedTipoPgtoEntrada: linkPagamento ? null : (formaEntrada?.cfpId != null ? String(formaEntrada.cfpId) : null),
                    pedFormaPgtoEntrada: linkPagamento ? null : (formaEntrada?.cfpNome || null),
                    pedTipoPgtoParcelas: linkPagamento ? null : (formaParcelas?.cfpId != null ? String(formaParcelas.cfpId) : null),
                    pedFormaPgtoParcelas: linkPagamento ? null : (formaParcelas?.cfpNome || null)
                };
                const endereco = {
                    ...this.enderecoEmRevisaoOriginal,
                    pedId: this.pedidoEmRevisaoId,
                    pdcEndereco: this.endereco,
                    pdcNumero: Number(this.numeroend),
                    pdcComplemento: this.complemento || '',
                    pdcCep: this.numCep,
                    pdcPais: 'Brasil',
                    pdcEstado: this.siglaEstado,
                    pdcCidade: this.nomeCidade,
                    pdcBairro: this.nomeBairro,
                    pdcTipo: this.tipoImovel,
                    pdcResidencialTipo: this.residencialTipo || ''
                };
                const pedidoItem = {
                    ...this.itemEmRevisaoOriginal,
                    pedId: this.pedidoEmRevisaoId,
                    proId: itemTela.proProdutos.proId,
                    pdiNomeProduto: itemTela.proProdutos.proNomeProduto,
                    pdiQtdeProduto: Number(itemTela.qtdeProduto || 1),
                    pdiValorProduto: Number(itemTela.valorProduto || 0),
                    pdiValorTotalProduto: Number(itemTela.valorTotalProduto || 0),
                    pdiCampoExtra1: String(itemTela.codSetup || 0),
                    pdiCampoExtra2: String(itemTela.taxa || 0),
                    pdiDataVigenciaIni: moment(itemTela.vigenciaini).format('YYYY-MM-DDTHH:mm:ss'),
                    pdiDataVigenciaFim: moment(itemTela.vigenciafim).format('YYYY-MM-DDTHH:mm:ss')
                };
                const itensAdicionais = (itemTela.proProdutos.proProdutosGrids || []).map(grid => ({
                    piaId: Number(grid.piaId || 0),
                    pedId: this.pedidoEmRevisaoId,
                    piaNomeProduto: grid.pisNome,
                    piaQtdeProduto: 1,
                    piaValorProduto: this.parseValorDecimal(grid.pisCampoExtra1),
                    piaValorTotalProduto: this.parseValorDecimal(grid.pisCampoExtra1),
                    piaDataCadastro: moment().format('YYYY-MM-DDTHH:mm:ss'),
                    piaCampoExtra1: ''
                }));

                await axios.put('/Telas/ContratacaoGarantia/UpdatePedidoAguardandoRevisao', { pedido, endereco, pedidoItem, itensAdicionais });
                const numero = this.pedidoEmRevisaoId;
                await this.LimparMemoria(0);
                await this.CarregarPedidosAguardandoAnalise();
                this.$mensagemAvisoSucesso(`Contratação ${numero} alterada e mantida aguardando envio.`);
            } catch (error) {
                this.$mensagemErro(error?.response?.data?.message || error?.response?.data?.Message || error?.message || 'Não foi possível alterar a contratação.');
            } finally {
                this.stopLoading();
            }
        },
        async GerarPedido(analisar) {
            await this.SalvarMemoria(2);

            let dadosArmazenados = localStorage.getItem(this.$DadosCompraManual);
            if (dadosArmazenados) {
                dadosArmazenados = JSON.parse(dadosArmazenados);
                if (dadosArmazenados.imobiliaria == '' || this.selectedImobiliaria == null) {
                    this.$mensagemAviso("Selecione imobiliaria.")
                }
                else if (dadosArmazenados.consumidor == '' || this.selectedConsumidor == null) {
                    this.$mensagemAviso("Selecione cliente.")
                }
                else if (dadosArmazenados.agenda[0].tipoImovel == '' || dadosArmazenados.agenda[0].tipoImovel == null) {
                    this.$mensagemAviso("Preencha tipo de imóvel no endereço.")
                }
                else if (dadosArmazenados.agenda[0].tipoImovel == 'Residencial' && (dadosArmazenados.agenda[0].residencialTipo == null || dadosArmazenados.agenda[0].residencialTipo == '')) {
                    this.$mensagemAviso("Preencha tipo de imóvel residencial no endereço.")
                }
                else if (dadosArmazenados.agenda[0].estado == '' || dadosArmazenados.agenda[0].estado == null) {
                    this.$mensagemAviso("Preencha sigla do estado do endereço.")
                }
                else if (dadosArmazenados.agenda[0].cidade == '' || dadosArmazenados.agenda[0].cidade == null) {
                    this.$mensagemAviso("Preencha cidade do endereco.")
                }
                else if (dadosArmazenados.agenda[0].bairro == null || dadosArmazenados.agenda[0].bairro == "") {
                    this.$mensagemAviso("Preencha o bairro do endereço.")
                }
                else if (dadosArmazenados.agenda[0].endereco == '' || dadosArmazenados.agenda[0].endereco == null) {
                    this.$mensagemAviso("Preencha endereço.")
                }
                else if (dadosArmazenados.agenda[0].numero == "" || dadosArmazenados.agenda[0].numero == null) {
                    this.$mensagemAviso("Preencha o número do endereço.")
                }
                else if (dadosArmazenados.agenda[0].cep == "" || dadosArmazenados.agenda[0].cep == null) {
                    this.$mensagemAviso("Preencha o CEP do endereço.")
                }
                else if (dadosArmazenados.produtos[0].length == 0) {
                    this.$mensagemAviso("Adicione um produto na lista.")
                }
                else if (dadosArmazenados.pagamento.length == 0) {
                    this.$mensagemAviso("Selecione forma de pagamento.")
                }
                else {
                    await this.CarregaPedido(analisar);
                             
                }
            }
        },
        async CarregaPedido(consulta) {
            this.startLoading();
            let dadosArmazenados = localStorage.getItem(this.$DadosCompraManual);
            if (dadosArmazenados) {
                dadosArmazenados = JSON.parse(dadosArmazenados);
                let _situacao = 'Aguardando Analise';
                let _pspId = 1;

                let valorTotalFinal = 0;
                let valorParcelas = 0;
                let qtdeParcelas = 0;
                let valorEntrada = 0;
                let setupEnt = dadosArmazenados.informacao[0].SetupEntrada == null ? 0 : dadosArmazenados.informacao[0].SetupEntrada;
                const pagamentoFlexivel = dadosArmazenados.informacao[0].PagamentoFlexivel || null;
                const pagamentoPorLink = pagamentoFlexivel?.linkPagamento === true;

                dadosArmazenados.produtos[0].forEach(itemprod => {
                const valor = parseFloat(itemprod.valorTotalProduto) || 0;
                valorTotalFinal += valor;
                });


                if (pagamentoPorLink) {
                    valorEntrada = 0;
                    valorParcelas = 0;
                    qtdeParcelas = 0;
                    setupEnt = false;
                }
                else if (pagamentoFlexivel) {
                    valorEntrada = Number(pagamentoFlexivel.valorTotalEntrada || 0);
                    valorParcelas = Number(pagamentoFlexivel.valorParcela || 0);
                    qtdeParcelas = Number(pagamentoFlexivel.quantidadeParcelas || 1);
                    setupEnt = pagamentoFlexivel.setupNaEntrada === true;
                }
                else if (setupEnt == 1 && dadosArmazenados.pagamento[0].cfpId == 3){
                    let _valorSetup = parseFloat(dadosArmazenados.produtos[0][0].codSetup);
                      valorParcelas = Math.round(((valorTotalFinal-_valorSetup) / 12) * 100) / 100;
                      valorEntrada = valorParcelas + _valorSetup;
                      qtdeParcelas = 11;
                }
                else if (setupEnt == 0 && dadosArmazenados.pagamento[0].cfpId == 3){
                    valorParcelas = Math.round((valorTotalFinal / 12) * 100) / 100;
                    qtdeParcelas = 12;
                }
                else if (setupEnt > 1 && setupEnt < 14 && dadosArmazenados.pagamento[0].cfpId == 3){
                    let _par = setupEnt - 1;
                    valorParcelas = Math.round((valorTotalFinal / _par) * 100) / 100;
                    qtdeParcelas = _par;
                }
                else if (setupEnt == 14 && dadosArmazenados.pagamento[0].cfpId == 3){
                    let _par = setupEnt - 2;
                    let _valorSetup = parseFloat(dadosArmazenados.produtos[0][0].codSetup);
                    valorParcelas = Math.round(((valorTotalFinal-_valorSetup) / _par) * 100) / 100;
                    valorEntrada = _valorSetup;
                    qtdeParcelas = _par;
                }
                else if (dadosArmazenados.pagamento[0].cfpId == 2){
                    valorParcelas = Math.round((valorTotalFinal / 12) * 100) / 100;
                    valorEntrada = valorParcelas;
                    qtdeParcelas = 11;
                }
                else if (setupEnt > 1 && dadosArmazenados.pagamento[0].cfpId == 4){
                    valorParcelas = Math.round((valorTotalFinal / 1) * 100) / 100;
                    valorEntrada = valorParcelas;
                    qtdeParcelas = 1;
                }
                else if (setupEnt == 1 && dadosArmazenados.pagamento[0].cfpId == 6){
                    let _valorSetup = parseFloat(dadosArmazenados.produtos[0][0].codSetup);
                      valorParcelas = Math.round(((valorTotalFinal-_valorSetup) / 12) * 100) / 100;
                      valorEntrada = valorParcelas + _valorSetup;
                      qtdeParcelas = 11;
                }
                else if (setupEnt == 0 && dadosArmazenados.pagamento[0].cfpId == 6){
                    valorParcelas = Math.round((valorTotalFinal / 12) * 100) / 100;
                    valorEntrada = valorParcelas;
                    qtdeParcelas = 11;
                }
                else if (setupEnt > 1 && dadosArmazenados.pagamento[0].cfpId == 6){
                      let _valorSetup = parseFloat(dadosArmazenados.produtos[0][0].codSetup);
                      valorParcelas = Math.round(((valorTotalFinal-_valorSetup) / 12) * 100) / 100;
                      valorEntrada = _valorSetup;
                      qtdeParcelas = 12;
                }
                else if (setupEnt > 1 && dadosArmazenados.pagamento[0].cfpId == 7){
                    let _par = setupEnt - 1;
                    valorParcelas = Math.round((valorTotalFinal / _par) * 100) / 100;
                    qtdeParcelas = _par;
                }


                //dados do pedido
                let _pedido = {
                    PedId: 0,
                    GrtId: 0,
                    CdtId: 0,
                    IdiId: 0,
                    PedDataPedido: moment().format('YYYY-MM-DDTHH:mm:ss'),
                    PedOrigemPedido: this.selectedGarantidora.garNomeEmpresa,
                    CliId: dadosArmazenados.consumidor[0].cliId,
                    ImobId: dadosArmazenados.imobiliaria[0].imoId,
                    GarId: dadosArmazenados.garantidora[0].garId,
                    PedFormaPgto: pagamentoPorLink ? 'Link de Pagamento' : (pagamentoFlexivel?.formaParcelas?.cfpNome || dadosArmazenados.pagamento[0].cfpNome),
                    PedTipoPgto: pagamentoPorLink ? '5' : String(pagamentoFlexivel?.formaParcelas?.cfpId || dadosArmazenados.pagamento[0].cfpId),
                    PedValorParcelas: valorParcelas,
                    PedQtdeParcelas: qtdeParcelas,
                    PedValorTotalPedido: valorTotalFinal,
                    PedObsLoja: '',
                    PedRetornoPgto: 'pending',
                    PedCodigoRetornoPgto: '',
                    PspId: _pspId,
                    PedSituacaoPedido: _situacao,
                    PedObsCliente: '',
                    PedUser: this.User.cusid,
                    PedValorEntrada: valorEntrada,
                    PedSetupEntrada: pagamentoPorLink ? false : (pagamentoFlexivel ? pagamentoFlexivel.setupNaEntrada === true : (setupEnt == 1 ? true : setupEnt == 14 ? true : false)),
                    PedPossuiEntrada: pagamentoPorLink ? false : (pagamentoFlexivel ? pagamentoFlexivel.possuiEntrada === true : null),
                    PedTipoPgtoEntrada: pagamentoPorLink ? null : (pagamentoFlexivel?.formaEntrada?.cfpId != null ? String(pagamentoFlexivel.formaEntrada.cfpId) : null),
                    PedFormaPgtoEntrada: pagamentoPorLink ? null : (pagamentoFlexivel?.formaEntrada?.cfpNome || null),
                    PedTipoPgtoParcelas: pagamentoPorLink ? null : (pagamentoFlexivel?.formaParcelas?.cfpId != null ? String(pagamentoFlexivel.formaParcelas.cfpId) : null),
                    PedFormaPgtoParcelas: pagamentoPorLink ? null : (pagamentoFlexivel?.formaParcelas?.cfpNome || null),
                    PedCiclo: 1
                }
                // console.log('_pedido')
                // console.log(_pedido)

                await axios.post(`/Telas/ContratacaoGarantia/AddPedidos`, _pedido)
                    .then(response => {
                        if (response.data > 0) {
                            _pedido.PedId = response.data;
                            this.NumeroPedido = _pedido.PedId;
                            console.log('_pedido adicionado')
                            // console.log(_pedido)                
                        }
                    });

                //itens do pedido
                let _pedidoItens = [];
                if (dadosArmazenados.produtos[0].length > 0) {
                    await dadosArmazenados.produtos[0].forEach((itemprod) => {
                        _pedidoItens.push(
                            {
                                PdiId: 0,
                                GrtId: 0,
                                CdtId: 0,
                                IdiId: 0,
                                PedId: _pedido.PedId,
                                ProId: itemprod.proProdutos.proId,
                                PdiNomeProduto: itemprod.proProdutos.proNomeProduto,
                                PdiQtdeProduto: parseInt(itemprod.qtdeProduto),
                                PdiValorProduto: parseFloat(itemprod.valorProduto),
                                PdiValorTotalProduto: itemprod.valorTotalProduto,
                                PdiDataCadastro: moment().format('YYYY-MM-DDTHH:mm:ss'),
                                PdiDataVigenciaIni: moment(itemprod.vigenciaini).format('YYYY-MM-DD'),
                                PdiDataVigenciaFim: moment(itemprod.vigenciafim).format('YYYY-MM-DD'),
                                PdiCampoExtra1: itemprod.codSetup.toString(),
                                PdiCampoExtra2: itemprod.taxa.toString(),
                                Grid: itemprod.proProdutos.proProdutosGrids,
                            }
                        );
                    });
                }

                //pedido Endereço
                let _pedidoEndereco = {
                    PdcId: 0,
                    GrtId: 0,
                    CdtId: 0,
                    IdiId: 0,
                    PdcEndereco: dadosArmazenados.agenda[0].endereco,
                    PdcNumero: parseInt(dadosArmazenados.agenda[0].numero, 10),
                    PdcComplemento: dadosArmazenados.agenda[0].complemento,
                    PdcObsEndereco: '',
                    pdcCep: dadosArmazenados.agenda[0].cep,
                    PdcPais: 'Brasil',
                    PdcEstado: dadosArmazenados.agenda[0].estado,
                    PdcCidade: dadosArmazenados.agenda[0].cidade,
                    PdcBairro: dadosArmazenados.agenda[0].bairro,
                    PedId: _pedido.PedId,
                    PdcTipo: dadosArmazenados.agenda[0].tipoImovel,
                    PdcresidencialTipo: dadosArmazenados.agenda[0].residencialTipo,
                }

                await axios.post(`/Telas/ContratacaoGarantia/AddPedidoEndereco`, _pedidoEndereco)
                    .then(response => {
                        if (response.data > 0) {
                            console.log('_pedidoEndereco adicionado')
                            //console.log(_pedidoEndereco)                
                        }
                    });

                const parseBR = str => {
                    if (typeof str !== 'string') return 0;
                    const cleaned = str.replace(/\./g, '').replace(/,/g, '.').trim();
                    const num = parseFloat(cleaned);
                    return isNaN(num) ? 0 : num;
                    };

                    for (const itens of _pedidoItens) {
                        let avulsosLocal = [];
                    try {
                        // 1) Insere o item principal
                        const { data: newId } = await axios.post(
                        `/Telas/ContratacaoGarantia/AddPedidoItem`,
                        itens
                        );

                        if (newId > 0) {

                        await this.ContratoAdd(_pedido.PedId, newId);

                        // 2) Prepara os avulsos
                        avulsosLocal = (itens.Grid || []).map(prod => {
                            const valor = parseBR(prod.pisCampoExtra1);
                            return {
                            PiaId: 0,
                            GrtId: 0,
                            CdtId: 0,
                            IdiId: 0,
                            PedId: _pedido.PedId,
                            PiaNomeProduto: prod.pisNome,
                            PiaQtdeProduto: 1,
                            PiaValorProduto: valor,
                            PiaValorTotalProduto: valor,
                            PiaDataCadastro: moment().format('YYYY-MM-DDTHH:mm:ss'),
                            PiaCampoExtra1: '',
                            };
                        });

                            // 4) Insere cada avulso
                            for (const av of avulsosLocal) {
                                await axios.post(`/Telas/ContratacaoGarantia/AddPedidoItemAdicional`, av);
                            }
                        }
                    }
                    catch (err) {
                        console.error('Erro ao processar itens do pedido:', err);
                        const corpoEmail = JSON.stringify(avulsosLocal, null, 2);
                        this.EnviaEmailAviso(corpoEmail);// aqui você pode decidir abortar tudo ou
                    }
                    }

                if (consulta === null) {
                    localStorage.removeItem(this.$DadosCompraManual);
                    await this.LimparMemoria(0);
                    this.$mensagemAvisoSucesso(`Contratação ${_pedido.PedId} salva. Ela aguarda uma ação de envio no topo desta tela.`);
                } else {
                    await this.ValidaAprovacao(_pedido, consulta);
                }

            }
        },
        async ValidaAprovacao(pedidoDados, consulta) {

            let dadosArmazenados = localStorage.getItem(this.$DadosCompraManual);

            if (dadosArmazenados) {
                dadosArmazenados = JSON.parse(dadosArmazenados);
                let _analiseCredito = {
                    pedId: pedidoDados.PedId,
                    documentoList: [dadosArmazenados.consumidor[0].cliDocumento.replaceAll('.', '').replaceAll('-', '').replaceAll('/','')],
                    fonteList: ['cdl', 'jus'], //retirado 'ser' 10-03-2026
                    validarRegra: true,
                    fazerAnalise: consulta,
                    garId: dadosArmazenados.garantidora[0].garId,
                    imoId: dadosArmazenados.imobiliaria[0].imoId,
                    cliId: dadosArmazenados.consumidor[0].cliId
                }

                await axios.post(`/Telas/ContratacaoGarantia/CheckAnaliseCredito`, _analiseCredito)
                    .then(response => {
                        console.log(response.data)
                    });
            }
            this.$router.push('/listacontratacoes')
        },
        calculatotal() {
            var valorProdutos = 0;
            var vcount = 0;

            if (this.ListaPedidoItem != '') {

                this.ListaPedidoItem.forEach(item => {
                    valorProdutos += item.valorTotalProduto;
                    vcount++;
                });
            }
            this.TotalPedido = (valorProdutos);

        },
        ExcluiProduto(index) {
            this.ListaPedidoItem.splice(index, 1);
            this.calculatotal();
            this.SalvarMemoria(2);
        },
        EditarProdutoContratacao(produto, index) {
            this.produtoEmEdicaoIndex = index;
            this.ProdutoSelected = {
                ...produto,
                proProdutos: {
                    ...(produto.proProdutos || {}),
                    proProdutosGrids: (produto.proProdutos?.proProdutosGrids || []).map(grid => ({ ...grid }))
                }
            };
            this.ProdutosGrid = this.ProdutoSelected.proProdutos.proProdutosGrids;
            this.PlanosGarantiasSelected = produto.codSetup ?? 0;
            this.ProdutosTaxas = produto.taxa ?? null;
            this.TipoCalculoTaxa = produto.tipoCalculoTaxa || 'taxa';
            this.ValorPacoteInformado = produto.valorPacoteInformado ?? null;
            this.Qtdemultiplicador = produto.cobertura || this.Qtdemultiplicador;
            this.CoberturaSelected = this.ListaPlanosCobertura.find(plano =>
                String(plano.ipcId) === String(produto.coberturaId)
            ) || this.CoberturaSelected;
            this.DataInicioVigenciaGarantia = moment(produto.vigenciaini).format('YYYY-MM-DD');
            this.DataFimVigenciaGarantia = moment(produto.vigenciafim).format('YYYY-MM-DD');
            this.dialogProdutoGarantia = true;
        },
        buildFileUrl(path) {
            if (!path) return '';
            const rel  = String(path).replace(/\\/g, '/'); // normaliza separadores
            const base = this.$imgURL;
            return `${base}/Telas/ContratacaoGarantia/GetFileByParam?param=${encodeURIComponent(rel)}&t=${Date.now()}`;
        },
        //pedido
        async ContratoAdd(_pedId, _pdiId) {
            let dadosArmazenados = localStorage.getItem(this.$DadosCompraManual);

            if (dadosArmazenados) {
                dadosArmazenados = JSON.parse(dadosArmazenados);

                //validar se o cliente tem um contrato especifico
                let _cmcId = 4;
                if (dadosArmazenados.consumidor[0].tpdId == 2) {
                    _cmcId = 5;
                }
                
                let result = this.ListaContratos.filter(x=> x.garId == this.selectedGarantidora.garId && x.tpdId == dadosArmazenados.consumidor[0].tpdId);
                if (result.length > 0){
                   _cmcId = result[0].cmcId;
                }

                var _dadosContrato = {
                    TipoPessoa: 4,
                    CmcId: _cmcId,
                    IdContratante: dadosArmazenados.consumidor[0].cliId,
                    IdContratada: dadosArmazenados.garantidora[0].garId,
                    dadosContratacao: {
                        idPedido: _pedId,
                        multiplicador: dadosArmazenados.avulsos[0].QtdeMultiplicador,
                        valorContratado: dadosArmazenados.produtos[0][0].valorTotalProduto.toString(),
                        custoSaida: '3x',
                        valorLocaticio: '0',
                        valorTaxa: dadosArmazenados.produtos[0][0].taxa.toString(),
                        setup: dadosArmazenados.produtos[0][0].codSetup.toString(),
                        tipoCalculoTaxa: (dadosArmazenados.produtos[0][0].tipoCalculoTaxa || 'taxa').toString(),
                        valorPacoteInformado: dadosArmazenados.produtos[0][0].valorPacoteInformado != null ? dadosArmazenados.produtos[0][0].valorPacoteInformado.toString() : null
                    }
                }

                var _pedidoDocumento = {
                    pftId: 0,
                    grtId: 0,
                    cdtId: 0,
                    pftUrlImagem: null,
                    pedId: _pedId,
                    pdiId: _pdiId,
                    pftDadosContrato: JSON.stringify(_dadosContrato.dadosContratacao)
                }

                await axios.post(`/Telas/ContratacaoGarantia/AddPedidoDocumento`, _pedidoDocumento)
                    .then(response => {
                        if (response.data > 0) {
                            _pedidoDocumento.pftId = response.data;
                        }
                    });
            }
        },
        //produtos
        toggle(mes) {
            this.ProdutoSelected = mes;
            if (mes.proProdutos.proId == 1 || mes.proProdutos.proId == 2) {
                let dadosArmazenados = localStorage.getItem(this.$DadosCompraManual);
                if (dadosArmazenados) {
                    dadosArmazenados = JSON.parse(dadosArmazenados);
                    if (dadosArmazenados.produtos.length > 0) {
                        this.ProdutosGrid = dadosArmazenados.produtos[0][0].proProdutos.proProdutosGrids;
                       //console.log('aqui1')
                        this.ProdutosGrid.forEach(element => {
                            if (element.pisCampoExtra1 == '' || element.pisCampoExtra1 == null) {
                                element.pisCampoExtra1 = 0;
                            }
                        });
                    }
                    else {
                        //console.log('aqui')
                        axios.get(`/Telas/ContratacaoGarantia/GetAllByProIdItens/${mes.proProdutos.proId}`)
                            .then(response => {
                                this.ProdutosGrid = response.data;
                                this.ProdutosGrid.forEach(element => {
                                    if (element.pisCampoExtra1 == '' || element.pisCampoExtra1 == null) {
                                        element.pisCampoExtra1 = 0;
                                    }
                                });
                            });
                    }
                }
                else {
                    axios.get(`/Telas/ContratacaoGarantia/GetAllByProIdItens/${mes.proProdutos.proId}`)
                        .then(response => {
                            this.ProdutosGrid = response.data; /*.sort((a, b) => {
                                                                            const valorA = parseInt(a.pimOrdem) || 0;
                                                                            const valorB = parseInt(b.pimOrdem) || 0;
                                                                            return valorA - valorB;
                                                                        });*/
                           // console.log('aqui2')
                            this.ProdutosGrid.forEach(element => {
                                if (element.pisCampoExtra1 == '' || element.pisCampoExtra1 == null) {
                                    element.pisCampoExtra1 = 0;
                                }
                            });

                            // console.log('mes')
                            // console.log(mes)

                            //  console.log('ProdutosGrid')
                            //  console.log(this.ProdutosGrid)

                        });
                }


                /*   axios.get(`/Process/ProProdutosPrecos/GetAllByPtcId/5/${mes.proProdutos.proId}`)
                   .then(response => {
                       this.ProdutosTaxas = response.data;                                                                 
                      // console.log('ProdutosTaxas')
                      // console.log(this.ProdutosTaxas)

                   });*/

                this.SincronizarCoberturaSelecionada();
                this.openModalProduto(1);

            }
        },
        openModalProduto(value) {
            if (value == 1) {
                this.produtoEmEdicaoIndex = null;
                this.AjustaDataFimVigenciaGarantia();
                this.dialogProdutoGarantia = true;
            }
            else {
                this.dialogProdutoSeguro = true;
            }
        },
        FecharModalProduto() {
            this.dialogProdutoGarantia = false;
            this.produtoEmEdicaoIndex = null;
        },
        AjustaDataFimVigenciaGarantia() {
            const dataInicio = moment(this.DataInicioVigenciaGarantia, 'YYYY-MM-DD', true);
            if (!dataInicio.isValid()) {
                this.DataFimVigenciaGarantia = '';
                return;
            }
            this.DataFimVigenciaGarantia = dataInicio.clone().add(12, 'months').format('YYYY-MM-DD');
        },
        ResetDatasVigenciaGarantia() {
            this.DataInicioVigenciaGarantia = moment().add(1, 'day').format('YYYY-MM-DD');
            this.AjustaDataFimVigenciaGarantia();
        },
        async AdicionarGarantia() {

            let _result = this.ProdutosGrid.filter(x => x.pisCampoExtra1 != 0 && x.pisCampoExtra1 != null && x.pisCampoExtra1 != '')
            if (this.selectedImobiliaria.planoCoberturaLivre == true && this.TipoCalculoTaxa == 'valor') {
                this.AtualizaTaxaPorValorPacote();
            }
            const taxaGarantiaCalculada = this.TaxaGarantiaComputed;
            this.AjustaDataFimVigenciaGarantia();
            const dataInicioVigencia = this.ControlaContratacoesPorDataVigencia
                ? moment(this.DataInicioVigenciaGarantia, 'YYYY-MM-DD', true)
                : moment();

            await axios.get(`/Telas/ContratacaoGarantia/GetByGarIdPlanos/` + this.selectedGarantidora.garId)
                .then(response => {
                    if (response.data.length > 0) {

                        if (_result.length == 0) {
                            this.$mensagemAviso("Pelo menos um valor precisa ser preenchido.")
                        }
                        else if (this.PlanosGarantiasSelected == '' || this.PlanosGarantiasSelected == null) {
                            this.$mensagemAviso("Selecione taxa de setup.")
                        }
                        else if (this.ControlaContratacoesPorDataVigencia && !dataInicioVigencia.isValid()) {
                            this.$mensagemAviso("Informe uma data de inicio da vigencia valida.")
                        }
                        else if (this.ControlaContratacoesPorDataVigencia && !dataInicioVigencia.isAfter(moment(), 'day')) {
                            this.$mensagemAviso("A data de inicio da vigencia deve ser maior que hoje.")
                        }
                        else if (this.selectedImobiliaria.planoCoberturaLivre == true && this.TipoCalculoTaxa == 'taxa' && (this.ProdutosTaxas == '' || this.ProdutosTaxas == null)) {
                            this.$mensagemAviso("Informe a taxa a ser aplicada.")
                        }
                        else if (this.selectedImobiliaria.planoCoberturaLivre == true && this.TipoCalculoTaxa == 'valor' && this.parseValorDecimal(this.ValorPacoteInformado) <= 0) {
                            this.$mensagemAviso("Digite o valor do pacote.")
                        }
                        else if (this.selectedImobiliaria.planoCoberturaLivre == true && this.TipoCalculoTaxa == 'valor' && this.ValorTotalComputed <= 0) {
                            this.$mensagemAviso("Informe os valores da cobertura para calcular a taxa.")
                        }
                        else if (this.selectedImobiliaria.planoCoberturaLivre == true && taxaGarantiaCalculada == null) {
                            this.$mensagemAviso("NÃ£o foi possÃ­vel calcular a taxa.")
                        }
                        else if (response.data[0].gplValorMaxSetup > this.PlanosGarantiasSelected) {
                            this.$mensagemAviso("Valor Setup deve ser acima de " + response.data[0].gplValorMaxSetup)
                        }
                        else if (this.selectedImobiliaria.planoCoberturaLivre == true && (this.Qtdemultiplicador == '' || this.Qtdemultiplicador == null)){
                            this.$mensagemAviso("Informe a quantidade de vezes da cobertura.")
                        } 
                         else if (this.selectedImobiliaria.planoCoberturaLivre == false && this.CoberturaSelected == null){
                            this.$mensagemAviso("Selecione Qtde Vezes Cobertura")
                        } 
                        else {
                            this.ListaPedidoItem = [];
                            var qtdeprod = 1;
                            const valorPacote = this.ValorPacoteGarantiaComputed;
                            const valorSetup = this.parseValorDecimal(this.PlanosGarantiasSelected);
                            this.ProdutoSelected.qtdeProduto = qtdeprod;
                            this.ProdutoSelected.valorTotalProduto = qtdeprod * (parseFloat(valorPacote) + parseFloat(valorSetup));
                            this.ProdutoSelected.valorProduto = (parseFloat(valorPacote) + parseFloat(valorSetup));
                            this.ProdutoSelected.codSetup = this.PlanosGarantiasSelected;
                            this.ProdutoSelected.taxa = taxaGarantiaCalculada;
                            this.ProdutoSelected.tipoCalculoTaxa = this.selectedImobiliaria.planoCoberturaLivre == true ? this.TipoCalculoTaxa : 'taxa';
                            this.ProdutoSelected.cobertura = this.Qtdemultiplicador;
                            this.ProdutoSelected.coberturaId = this.CoberturaSelected?.ipcId ?? null;
                            this.ProdutoSelected.valorPacoteInformado = this.ProdutoSelected.tipoCalculoTaxa == 'valor' ? valorPacote : null;
                            this.ProdutoSelected.vigenciaini = dataInicioVigencia.clone();
                            this.ProdutoSelected.vigenciafim = dataInicioVigencia.clone().add(12, 'months');
                            this.ProdutoSelected.proProdutos.proProdutosGrids = this.ProdutosGrid;
                            this.ListaPedidoItem.push(this.ProdutoSelected);
                            this.SalvarMemoria(2);
                            this.dialogProdutoGarantia = false;
                            this.produtoEmEdicaoIndex = null;
                            this.calculatotal();
                        }
                    }
                });

        },
        //produtos
        parseValorDecimal(value) {
            if (value == null || value === '') return 0;
            let v = value;
            if (typeof v === "string") {
                v = v.replace(/\./g, "");
                v = v.replace(/,/g, ".");
            }
            const num = parseFloat(v);
            return isNaN(num) ? 0 : num;
        },
        AtualizaTipoCalculoTaxa() {
            this.ProdutosTaxas = null;
            this.ValorPacoteInformado = null;
        },
        AtualizaTaxaPorValorPacote() {
            this.ProdutosTaxas = this.TaxaGarantiaComputed;
        },
        formatarPercentualTaxa(value) {
            const taxa = parseFloat(value);
            if (isNaN(taxa)) return '0%';
            return `${(taxa * 100).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 4 })}%`;
        },
        AtualizaTaxasPlanos() {
            if (this.CoberturaSelected != null){
                this.ProdutosTaxas = this.CoberturaSelected.ipcPercentualGarantia;
                this.Qtdemultiplicador = this.CoberturaSelected.ipcCobertura + 'x';
                this.PersistirCobertura();
            }
            else{
                this.ProdutosTaxas = null;
                this.Qtdemultiplicador = null;
                this.PersistirCobertura();
            }
        },
        PersistirCobertura() {
            const item = Array.isArray(this.ListaPedidoItem) ? this.ListaPedidoItem[0] : null;
            if (item) {
                item.cobertura = this.Qtdemultiplicador;
                item.coberturaId = this.CoberturaSelected?.ipcId ?? null;
            }
            this.SalvarMemoria(2);
        },
        SincronizarCoberturaSelecionada() {
            if (!this.selectedImobiliaria || this.selectedImobiliaria.planoCoberturaLivre == true) return;

            const item = Array.isArray(this.ListaPedidoItem) ? this.ListaPedidoItem[0] : null;
            const dadosArmazenados = JSON.parse(localStorage.getItem(this.$DadosCompraManual) || 'null');
            const coberturaId = item?.coberturaId ?? dadosArmazenados?.avulsos?.[0]?.CoberturaId;
            const cobertura = item?.cobertura ?? dadosArmazenados?.avulsos?.[0]?.QtdeMultiplicador ?? this.Qtdemultiplicador;
            const quantidade = String(cobertura ?? '').replace(/x$/i, '').trim();

            this.CoberturaSelected = this.ListaPlanosCobertura.find(plano =>
                (coberturaId != null && String(plano.ipcId) === String(coberturaId)) ||
                (quantidade !== '' && String(plano.ipcCobertura) === quantidade)
            ) || null;

            if (this.CoberturaSelected) {
                this.ProdutosTaxas = this.CoberturaSelected.ipcPercentualGarantia;
                this.Qtdemultiplicador = `${this.CoberturaSelected.ipcCobertura}x`;
            }
        },
        formattedDate(value) {
            if (value != null || value != "") {
                return this.$moment(value).format('DD/MM/YYYY')
            }
            else {
                return "";
            }

        },
        formatarValor(valor) {
            return valor.toLocaleString('pt-BR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
            });
        },
        async ValidaDadosGarantidora(garid) {
            console.log('1: Iniciando validação de garantidora');

            try {
                // 1) Busca dados da garantidora
                const { data: garantidora } = await axios.get(`/Telas/ContratacaoGarantia/GetByIdGarantidora/${garid}`);
                console.log('2: Dados da garantidora recebidos');

                // Valida campos obrigatórios da garantidora
                if (garantidora == null || garantidora === '') {
                    this.$mensagemAviso("Garantidora não encontrada.");
                    return false;
                }
                if (garantidora.tpdId == null) {
                    this.$mensagemAviso("Garantidora Campo Tipo Pessoa Obrigatório.");
                    return false;
                }
                if (garantidora.garDocumento == null || garantidora.garDocumento === '') {
                    this.$mensagemAviso("Garantidora Campo Nº Documento Obrigatório.");
                    return false;
                }
                if (garantidora.garNomeEmpresa == null || garantidora.garNomeEmpresa === '') {
                    this.$mensagemAviso("Garantidora Campo Nome Obrigatório.");
                    return false;
                }
                if ((garantidora.garRazaoSocial == null || garantidora.garRazaoSocial === '') && garantidora.tpdId == 2) {
                    this.$mensagemAviso("Garantidora Campo Razão Social Obrigatório.");
                    return false;
                }
                if (garantidora.garTelefone == null || garantidora.garTelefone === '') {
                    this.$mensagemAviso("Garantidora Campo Telefone Obrigatório.");
                    return false;
                }
                if (garantidora.garWhatsapp == null || garantidora.garWhatsapp === '') {
                    this.$mensagemAviso("Garantidora Campo Whatsapp Obrigatório.");
                    return false;
                }
                if (garantidora.garEmail == null || garantidora.garEmail === '') {
                    this.$mensagemAviso("Garantidora Campo E-mail Obrigatório.");
                    return false;
                }
                if (garantidora.tpdId === 2 && (garantidora.garResponsavel == null || garantidora.garResponsavel === '')) {
                    this.$mensagemAviso("Garantidora Campo Responsável Obrigatório.");
                    return false;
                }
                if (garantidora.tpdId === 2 && (garantidora.garCampoExtra1 == null || garantidora.garCampoExtra1 === '')) {
                    this.$mensagemAviso("Garantidora Campo CPF Responsável Obrigatório.");
                    return false;
                }

                console.log('3: Garantidora OK, buscando endereço');

                // 2) Busca dados de endereço
                const { data: enderecos } = await axios.get(`/Telas/ContratacaoGarantia/GetByGarIdEndereco/${garid}`);
                const endereco = Array.isArray(enderecos) ? enderecos[0] : null;

                if (endereco == null) {
                    this.$mensagemAviso("Endereço Garantidora não encontrado.");
                    return false;
                }
                if (endereco.gaeCep == null || endereco.gaeCep === '') {
                    this.$mensagemAviso("Endereço Garantidora - Campo CEP Obrigatório.");
                    return false;
                }
                if (endereco.gaeEndereco == null || endereco.gaeEndereco === '') {
                    this.$mensagemAviso("Endereço Garantidora - Campo Endereço Obrigatório.");
                    return false;
                }
                // aceita 0, mas reprova '' ou null/undefined
                if (endereco.gaeNumero == null || endereco.gaeNumero === '') {
                    this.$mensagemAviso("Endereço Garantidora - Campo Número Obrigatório.");
                    return false;
                }
                if (endereco.gaeEstado == null || endereco.gaeEstado === '') {
                    this.$mensagemAviso("Endereço Garantidora - Campo Estado Obrigatório.");
                    return false;
                }
                if (endereco.gaeCidade == null || endereco.gaeCidade === '') {
                    this.$mensagemAviso("Endereço Garantidora - Campo Cidade Obrigatório.");
                    return false;
                }
                if (endereco.gaeBairro == null || endereco.gaeBairro === '') {
                    this.$mensagemAviso("Endereço Garantidora - Campo Bairro Obrigatório.");
                    return false;
                }

                console.log('4: Endereço OK, validação completa');
                return true;
            }
            catch (error) {
                console.error('Erro na ValidaDadosGarantidora:', error);
                this.$mensagemErro("Falha ao validar dados da garantidora. Tente novamente.");
                return false;
            }
        },
        async ValidaDadosImobiliaria(imoId) {
            console.log('1: Iniciando validação de imobiliária');

            try {
                // 1) Busca dados da imobiliária
                const { data: imobiliaria } = await axios.get(`/Telas/ContratacaoGarantia/GetByIdImobiliaria/${imoId}`);
                console.log('2: Dados da imobiliária recebidos');

                // Validações da Imobiliária
                if (imobiliaria.garId == null || imobiliaria.garId === '') {
                    this.$mensagemAviso("Imobiliária - Campo Garantidora Obrigatório.");
                    return false;
                }
                if (imobiliaria.tpdId == null || imobiliaria.tpdId === '') {
                    this.$mensagemAviso("Imobiliária - Campo Tipo Pessoa Obrigatório.");
                    return false;
                }
                if (imobiliaria.imoDocumento == null || imobiliaria.imoDocumento === '') {
                    this.$mensagemAviso("Imobiliária - Campo Nº Documento Obrigatório.");
                    return false;
                }
                if (imobiliaria.imoNomeEmpresa == null || imobiliaria.imoNomeEmpresa === '') {
                    this.$mensagemAviso("Imobiliária - Campo Nome Obrigatório.");
                    return false;
                }
                if (imobiliaria.tpdId === 2 && (imobiliaria.imoRazaoSocial == null || imobiliaria.imoRazaoSocial === '')) {
                    this.$mensagemAviso("Imobiliária - Campo Razão Social Obrigatório.");
                    return false;
                }
                if (imobiliaria.imoTelefone == null || imobiliaria.imoTelefone === '') {
                    this.$mensagemAviso("Imobiliária - Campo Telefone Obrigatório.");
                    return false;
                }
                if (imobiliaria.imoWhatsapp == null || imobiliaria.imoWhatsapp === '') {
                    this.$mensagemAviso("Imobiliária - Campo Whatsapp Obrigatório.");
                    return false;
                }
                if (imobiliaria.imoEmail == null || imobiliaria.imoEmail === '') {
                    this.$mensagemAviso("Imobiliária - Campo E-mail Obrigatório.");
                    return false;
                }
                if (imobiliaria.tpdId === 2 && (imobiliaria.imoResponsavel == null || imobiliaria.imoResponsavel === '')) {
                    this.$mensagemAviso("Imobiliária - Campo Responsável Obrigatório.");
                    return false;
                }
                if (imobiliaria.tpdId === 2 && (imobiliaria.imoCampoExtra1 == null || imobiliaria.imoCampoExtra1 === '')) {
                    this.$mensagemAviso("Imobiliária - Campo CPF Responsável Obrigatório.");
                    return false;
                }
                if (imobiliaria.imoCreci == null || imobiliaria.imoCreci === '') {
                    this.$mensagemAviso("Imobiliária - Campo Creci Obrigatório.");
                    return false;
                }

                console.log('3: Imobiliária OK, buscando endereço');

                // 2) Busca dados de endereço da imobiliária
                const { data: enderecos } = await axios.get(`/Telas/ContratacaoGarantia/GetByImoIdEndereco/${imoId}`);
                const endereco = Array.isArray(enderecos) ? enderecos[0] : null;

                if (endereco == null) {
                    this.$mensagemAviso("Endereço da Imobiliária não encontrado.");
                    return false;
                }
                if (endereco.imeCep == null || endereco.imeCep === '') {
                    this.$mensagemAviso("Campo CEP da Imobiliária Obrigatório.");
                    return false;
                }
                if (endereco.imeEndereco == null || endereco.imeEndereco === '') {
                    this.$mensagemAviso("Campo Endereço da Imobiliária Obrigatório.");
                    return false;
                }
                if (endereco.imeNumero == null || endereco.imeNumero === '') {
                    this.$mensagemAviso("Campo Número da Imobiliária Obrigatório.");
                    return false;
                }
                if (endereco.imeEstado == null || endereco.imeEstado === '') {
                    this.$mensagemAviso("Campo Estado da Imobiliária Obrigatório.");
                    return false;
                }
                if (endereco.imeCidade == null || endereco.imeCidade === '') {
                    this.$mensagemAviso("Campo Cidade da Imobiliária Obrigatório.");
                    return false;
                }
                if (endereco.imeBairro == null || endereco.imeBairro === '') {
                    this.$mensagemAviso("Campo Bairro da Imobiliária Obrigatório.");
                    return false;
                }

                // 3) Busca dados de Planos cobertura da imobiliária
                const { data: planos } = await axios.get(`/Telas/ContratacaoGarantia/GetPlanosCoberturaByImoId/${imoId}`);
                this.ListaPlanosCobertura = planos;
                this.SincronizarCoberturaSelecionada();
              
                if (imobiliaria.planoCoberturaLivre == false && 
                    (this.ListaPlanosCobertura.filter(x=> x.ipcTipoCobertura == 'Residencial').length == 0 
                    || this.ListaPlanosCobertura.filter(x=> x.ipcTipoCobertura == 'Comercial').length == 0)){
                     this.$mensagemAvisoConfirm("Necessário cadastro de Planos de Cobertura, entre em contato com Garantidora.");
                    return false;
                }
                console.log('4: Endereço OK, validação completa');
                return true;
            }
            catch (error) {
                console.error('Erro na ValidaDadosImobiliaria:', error);
                this.$mensagemErro("Falha ao validar dados da imobiliária. Tente novamente.");
                return false;
            }
        },
        async ValidaDadosCliente(cliId) {
            console.log('1: Iniciando validação de cliente');
            try {
                // 1) Carrega dados do cliente
                const { data: cliente } = await axios.get(`/Telas/ContratacaoGarantia/GetByIdCliente/${cliId}`);
                console.log('2: Dados do cliente recebidos', cliente);

                // 2) Validações básicas
                if (cliente.garId == null || cliente.garId === '') {
                    this.$mensagemAviso("Cadastro do Cliente - Campo Garantidora Obrigatório.");
                    return false;
                }
                if (cliente.imoId == null || cliente.imoId === '') {
                    this.$mensagemAviso("Cadastro do Cliente - Campo Imobiliária Obrigatório.");
                    return false;
                }
                if (cliente.tpdId == null || cliente.tpdId === '') {
                    this.$mensagemAviso("Cadastro do Cliente - Campo Tipo Pessoa Obrigatório.");
                    return false;
                }
                if (cliente.cliDocumento == null || cliente.cliDocumento === '') {
                    this.$mensagemAviso("Cadastro do Cliente - Campo Nº Documento Obrigatório.");
                    return false;
                }
                if (cliente.cliNomeEmpresa == null || cliente.cliNomeEmpresa === '') {
                    this.$mensagemAviso("Cadastro do Cliente - Campo Nome Obrigatório.");
                    return false;
                }
                if (cliente.cliTelefone == null || cliente.cliTelefone === '') {
                    this.$mensagemAviso("Cadastro do Cliente - Campo Telefone Obrigatório.");
                    return false;
                }
                if (cliente.cliWhatsapp == null || cliente.cliWhatsapp === '') {
                    this.$mensagemAviso("Cadastro do Cliente - Campo Whatsapp Obrigatório.");
                    return false;
                }
                // PF exige data de nascimento
                if (
                    cliente.tpdId === 1 &&
                    (cliente.cliDataNascimento == null || cliente.cliDataNascimento === '')
                ) {
                    this.$mensagemAviso("Cadastro do Cliente - Campo Data Nascimento Obrigatório.");
                    return false;
                }
                if (cliente.cliEmail == null || cliente.cliEmail === '') {
                    this.$mensagemAviso("Cadastro do Cliente - Campo E-mail Obrigatório.");
                    return false;
                }
                // PJ exige responsável e CPF
                if (
                    cliente.tpdId === 2 &&
                    (cliente.cliResponsavel == null || cliente.cliResponsavel === '')
                ) {
                    this.$mensagemAviso("Cadastro do Cliente - Campo Responsável Obrigatório.");
                    return false;
                }
                if (
                    cliente.tpdId === 2 &&
                    (cliente.cliCampoExtra1 == null || cliente.cliCampoExtra1 === '')
                ) {
                    this.$mensagemAviso("Cadastro do Cliente - Campo CPF Responsável Obrigatório.");
                    return false;
                }
                // Campos adicionais PF
                if (cliente.tpdId === 1) {
                    if (cliente.cliNomePai == null || cliente.cliNomePai === '') {
                        this.$mensagemAviso("Cadastro do Cliente - Campo Nome Pai Obrigatório.");
                        return false;
                    }
                    if (cliente.cliNomeMae == null || cliente.cliNomeMae === '') {
                        this.$mensagemAviso("Cadastro do Cliente - Campo Nome Mãe Obrigatório.");
                        return false;
                    }
                    if (cliente.cliEstadoCivil == null || cliente.cliEstadoCivil === '') {
                        this.$mensagemAviso("Cadastro do Cliente - Campo Estado Civil Obrigatório.");
                        return false;
                    }
                }
                console.log('3: Cliente OK, buscando endereço cadastrado');

                // 3) Valida endereço cadastrado
                const { data: enderecos } = await axios.get(
                    `/Telas/ContratacaoGarantia/GetEnderecoByCli/${cliId}`
                );
                const endereco = Array.isArray(enderecos) ? enderecos[0] : null;
                if (endereco == null) {
                    this.$mensagemAviso("Endereço do cadastro do cliente não foi localizado.");
                    return false;
                }
                if (endereco.cleCep == null || endereco.cleCep === '') {
                    this.$mensagemAviso("Campo CEP do cadastro do cliente Obrigatório.");
                    return false;
                }
                if (endereco.cleEndereco == null || endereco.cleEndereco === '') {
                    this.$mensagemAviso("Campo Endereço do cadastro do cliente Obrigatório.");
                    return false;
                }
                if (endereco.cleNumero == null || endereco.cleNumero === '') {
                    this.$mensagemAviso("Campo Número do cadastro do cliente Obrigatório.");
                    return false;
                }
                if (endereco.cleEstado == null || endereco.cleEstado === '') {
                    this.$mensagemAviso("Campo Estado do cadastro do cliente Obrigatório.");
                    return false;
                }
                if (endereco.cleCidade == null || endereco.cleCidade === '') {
                    this.$mensagemAviso("Campo Cidade do cadastro do cliente Obrigatório.");
                    return false;
                }
                if (endereco.cleBairro == null || endereco.cleBairro === '') {
                    this.$mensagemAviso("Campo Bairro do cadastro do cliente Obrigatório.");
                    return false;
                }

                console.log('4: Endereço OK, validação completa');
                return true;
            }
            catch (error) {
                console.error('Erro na ValidaDadosCliente:', error);
                this.$mensagemErro("Falha ao validar dados do cliente. Tente novamente.");
                return false;
            }
        },
        EnviaEmailAviso(texto){
              axios.get(`/Telas/ContratacaoGarantia/GetByIdMensagemPadrao/16?garId=${this.PedidosCli?.garId || this.User?.garid || 0}`)
                      .then(response => {
                        this.templateEmail = response.data;
                            let _dadosEmail = {
                                            nomeDe: this.$GarantePayNome,
                                            nomePara: "Luciano",
                                            assunto: 'Erro Pedido Adicional - Sistema GarantePay',
                                            destinatario: "contato@avancedigital.com.br",
                                            emailResposta: "contato@avancedigital.com.br",
                                            textoEmail: this.templateEmail.mpdTexto
                                                        .replace('[Texto]',texto),
                                            listAnexos: null //{nomeAnexo: '', anexo: '', tipoAnexo: ''}
                                        }
                                axios.post(`/Telas/ContratacaoGarantia/Enviamail`,_dadosEmail);
            });
        },
        async Get() {
            await this.CarregarPedidosAguardandoAnalise();
            await axios.get(`/Telas/ContratacaoGarantia/GetDados`)
               .then(response => {
                   this.Situacoes = response.data.cadSituacaoPedido;
                   this.ListProdutosGeral = response.data.produtosSegmentos.filter(x => x.proProdutos.proVisivel);
                    this.ListProdutosGeral = this.ListProdutosGeral.map(item => {
                        return {
                            ...item,
                            nomeConcatenado: `${item.proProdutos.proNomeProduto}`
                        };
                    });
                    // Fazer a distinção dos itens com base na propriedade nomeConcatenado
                    const distinctItems = this.ListProdutosGeral.filter((item, index, self) =>
                        index === self.findIndex(t => (
                            t.nomeConcatenado === item.nomeConcatenado
                        ))
                    );
                    this.ListProdutosGeral = distinctItems.sort((a, b) => {
                        const nomeA = a.proProdutos.proNomeProduto || "";
                        const nomeB = b.proProdutos.proNomeProduto || "";
                        return nomeA.localeCompare(nomeB);
                    });

                    this.ListaContratos = response.data.modelosContratos;
               
                this.User.tpeid = response.data.tpeId
                this.User.garid = response.data.garId
                this.User.pesid = response.data.pesId
                this.User.cusid = response.data.cusId;
                
                 this.DadosGarantidora = response.data.garantidoras.filter(x => x.garVisivel).sort((a, b) =>
                        a.garNomeEmpresa.localeCompare(
                        b.garNomeEmpresa,
                        'pt',
                        { sensitivity: 'base' }
                        )
                    );
                    if (this.User.garid != 0) {
                        this.selectedGarantidora = this.DadosGarantidora[0];
                        this.BuscaImobialiarias();
                    }
                    this.DadosConfiguracao = response.data.garantidoraSerasa;
                    this.TipoOperadoras = response.data.tipoOperadoras;
         });           

            let dadosArmazenados = localStorage.getItem(this.$DadosCompraManual);
            if (dadosArmazenados) {
                dadosArmazenados = JSON.parse(dadosArmazenados);
                if (dadosArmazenados.revisao?.pedId) {
                    this.pedidoEmRevisaoId = Number(dadosArmazenados.revisao.pedId);
                    this.pedidoEmRevisaoOriginal = dadosArmazenados.revisao.pedido || null;
                    this.enderecoEmRevisaoOriginal = dadosArmazenados.revisao.endereco || null;
                    this.itemEmRevisaoOriginal = dadosArmazenados.revisao.pedidoItem || null;
                    this.exibirFormulario = true;
                }
                if (dadosArmazenados.consumidor != '') {
                    this.selectedGarantidora = dadosArmazenados.garantidora[0];
                    await this.BuscaImobialiarias();
                    this.selectedImobiliaria = dadosArmazenados.imobiliaria[0];
                    this.SelecionarConsumidor();
                    this.selectedConsumidor = dadosArmazenados.consumidor[0];

                    if (dadosArmazenados.agenda != '') {
                        //endereco
                        this.tipoImovel = dadosArmazenados.agenda[0].tipoImovel;
                        this.nomeCidade = dadosArmazenados.agenda[0].cidade;
                        this.siglaEstado = dadosArmazenados.agenda[0].estado;
                        this.nomeBairro = dadosArmazenados.agenda[0].bairro;
                        this.endereco = dadosArmazenados.agenda[0].endereco;
                        this.numeroend = dadosArmazenados.agenda[0].numero;
                        this.complemento = dadosArmazenados.agenda[0].complemento;
                        this.numCep = dadosArmazenados.agenda[0].cep;
                        this.residencialTipo = dadosArmazenados.agenda[0].residencialTipo;
                        this.teste = dadosArmazenados.agenda[0].residencialTipo;
                        this.showend = true;
                        this.liberaEndGarantia = true;
                    }
                     console.log('this.residencialTipo')
                     console.log(this.residencialTipo)
                    //console.log('this.ListProdutosGeral')
                    // console.log(this.ListProdutosGeral)

                    this.ListProdutos = this.ListProdutosGeral.filter(x =>
                        x.proProdutos.proNomeProduto && this.tipoImovel &&
                        x.proProdutos.proNomeProduto.toLowerCase().includes(this.tipoImovel.toLowerCase())
                    );


                    //produtos
                    if (dadosArmazenados.produtos != '') {
                        this.ListaPedidoItem = dadosArmazenados.produtos[0];
                        this.PlanosGarantiasSelected = dadosArmazenados.produtos[0][0].codSetup;
                        this.ProdutosTaxas = dadosArmazenados.produtos[0][0].taxa;
                        this.TipoCalculoTaxa = dadosArmazenados.produtos[0][0].tipoCalculoTaxa || 'taxa';
                        this.ValorPacoteInformado = dadosArmazenados.produtos[0][0].valorPacoteInformado;
                        this.Qtdemultiplicador = dadosArmazenados.produtos[0][0].cobertura || dadosArmazenados.avulsos?.[0]?.QtdeMultiplicador || null;
                        dadosArmazenados.produtos[0][0].coberturaId = dadosArmazenados.produtos[0][0].coberturaId ?? dadosArmazenados.avulsos?.[0]?.CoberturaId ?? null;
                        if (!dadosArmazenados.produtos[0][0].cobertura) dadosArmazenados.produtos[0][0].cobertura = this.Qtdemultiplicador;
                        this.SincronizarCoberturaSelecionada();
                        this.DataInicioVigenciaGarantia = moment(dadosArmazenados.produtos[0][0].vigenciaini).format('YYYY-MM-DD');
                        this.DataFimVigenciaGarantia = moment(dadosArmazenados.produtos[0][0].vigenciafim).format('YYYY-MM-DD');
                    }
                    //pagamento
                    const configuracao = dadosArmazenados.informacao?.[0]?.PagamentoFlexivel;
                    if (configuracao) {
                        this.pagamentoFlexivel = {
                            linkPagamento: configuracao.linkPagamento === true,
                            possuiEntrada: configuracao.possuiEntrada === true,
                            valorEntrada: configuracao.valorEntrada ?? '',
                            setupNaEntrada: configuracao.setupNaEntrada === true,
                            quantidadeParcelas: configuracao.quantidadeParcelas || 12,
                            formaEntrada: configuracao.formaEntrada || null,
                            formaParcelas: configuracao.formaParcelas || null
                        };
                    }
                    if (dadosArmazenados.pagamento != '') {
                        this.selectedFormaPagamento = dadosArmazenados.pagamento[0];
                        if (!this.pagamentoFlexivel.linkPagamento && !this.pagamentoFlexivel.formaParcelas) this.pagamentoFlexivel.formaParcelas = dadosArmazenados.pagamento[0];
                    }
                    //% tacas
                    this.ListaProdutosTaxasFilter = this.ListaProdutosTaxas.filter(x => x.tipo === dadosArmazenados.agenda[0].tipoImovel);

                    this.calculatotal();
                }
            }
        }
    },
    created() {
        this.Get();
    },
    computed: {
        FormasPagamentoSemLink() {
            return (this.ListaFormasPagamento || []).filter(item =>
                String(item.cfpId) !== '5' &&
                !String(item.cfpNome || '').toLocaleLowerCase('pt-BR').includes('link de pagamento')
            );
        },
        DataMinimaVigencia() {
            return moment().add(1, 'day').format('YYYY-MM-DD');
        },
        ValorSetupPagamento() {
            const item = Array.isArray(this.ListaPedidoItem) ? this.ListaPedidoItem[0] : null;
            return Number(this.parseValorDecimal(item?.codSetup).toFixed(2));
        },
        ValorGarantiaSemSetup() {
            return Math.max(0, Number((Number(this.TotalPedido || 0) - this.ValorSetupPagamento).toFixed(2)));
        },
        ValorEntradaGarantia() {
            if (!this.pagamentoFlexivel.possuiEntrada) return 0;
            return Math.min(this.ValorGarantiaSemSetup, this.parseValorDecimal(this.pagamentoFlexivel.valorEntrada));
        },
        ValorTotalEntrada() {
            return Number((this.ValorEntradaGarantia + (this.pagamentoFlexivel.setupNaEntrada ? this.ValorSetupPagamento : 0)).toFixed(2));
        },
        SaldoPagamentoFlexivel() {
            return Math.max(0, Number((Number(this.TotalPedido || 0) - this.ValorTotalEntrada).toFixed(2)));
        },
        ValorParcelaFlexivel() {
            const quantidade = Math.min(12, Math.max(1, Number(this.pagamentoFlexivel.quantidadeParcelas) || 1));
            return Number((this.SaldoPagamentoFlexivel / quantidade).toFixed(2));
        },
        CoberturaLivreInput: {
            get() {
                return this.Qtdemultiplicador == null ? '' : String(this.Qtdemultiplicador).replace(/x$/i, '');
            },
            set(value) {
                const quantidade = parseInt(value, 10);
                this.Qtdemultiplicador = Number.isFinite(quantidade) && quantidade > 0 ? `${quantidade}x` : null;
            }
        },
        TaxaLivreInput: {
            get() {
                const taxa = Number(this.ProdutosTaxas);
                if (!Number.isFinite(taxa)) return '';
                return Number((taxa * 100).toFixed(4)).toLocaleString('pt-BR', { maximumFractionDigits: 4 });
            },
            set(value) {
                const texto = String(value ?? '').replace('%', '').trim();
                const normalizado = texto.includes(',')
                    ? texto.replace(/\./g, '').replace(',', '.')
                    : texto;
                const percentual = Number(normalizado);
                this.TipoCalculoTaxa = 'taxa';
                this.ValorPacoteInformado = null;
                this.ProdutosTaxas = Number.isFinite(percentual) && percentual >= 0
                    ? Number((percentual / 100).toFixed(6))
                    : null;
            }
        },
        ControlaContratacoesPorDataVigencia() {
            return this.selectedGarantidora != null;
        },
        TaxaGarantiaComputed() {
            if (this.selectedImobiliaria && this.selectedImobiliaria.planoCoberturaLivre == true && this.TipoCalculoTaxa == 'valor') {
                const valorPacote = this.parseValorDecimal(this.ValorPacoteInformado);
                if (valorPacote > 0 && this.ValorTotalComputed > 0) {
                    return Number((valorPacote / this.ValorTotalComputed).toFixed(6));
                }
                return null;
            }

            const taxa = parseFloat(this.ProdutosTaxas);
            return isNaN(taxa) ? null : taxa;
        },
        ExibeResultadoGarantia() {
            if (this.selectedImobiliaria && this.selectedImobiliaria.planoCoberturaLivre == true && this.TipoCalculoTaxa == 'valor') {
                return this.ValorPacoteGarantiaComputed > 0 && this.TaxaGarantiaComputed != null;
            }

            return this.ProdutosTaxas != '' && this.ProdutosTaxas != null;
        },
        ValorPacoteGarantiaComputed() {
            if (this.selectedImobiliaria && this.selectedImobiliaria.planoCoberturaLivre == true && this.TipoCalculoTaxa == 'valor') {
                return Number(this.parseValorDecimal(this.ValorPacoteInformado).toFixed(2));
            }
            const taxa = this.TaxaGarantiaComputed;
            if (taxa == null) return 0;
            return Number((this.ValorTotalComputed * taxa).toFixed(2));
        },
        ValorTotalComputed() {
               let valorTotal = 0;
               let lista = [];
            
               if (this.selectedGarantidora.garId == 31){
                lista.push(this.ProdutosGrid[0]);
               }
               else{
                lista = this.ProdutosGrid;
               }

                lista.forEach(el => {
                let v = el.pisCampoExtra1;
                if (typeof v === "string") {
                    // 1) remove pontos de milhar (ex: "1.234,56" → "1234,56")
                    v = v.replace(/\./g, "");
                    // 2) troca vírgula decimal por ponto (ex: "1234,56" → "1234.56")
                    v = v.replace(/,/g, ".");
                }
                const num = parseFloat(v);
                if (!isNaN(num)) {
                    valorTotal += num;
                }
                });

                // multiplica por 12
                const totalAnual = valorTotal * 12;
                // garante duas casas decimais e devolve como Number
                return Number(totalAnual.toFixed(2));
        },
        subtiposDisponiveis() {
        const tipo = this.tiposImoveis.find(t => t.id === this.tipoImovel);
        return tipo ? tipo.subtipos : [];
        }
    },
}
</script>

<style scoped>
.tabinfo {
    font-size: 14px;
    text-transform: capitalize;
}


td {
    border: 1px solid #333333;
    padding: 3px;
}

.small-text {
    font-size: 10px;
    color: #dc2626;
    margin-top: 0px !important;
    position: absolute;
}


@media (min-width:1200px) {

    .fonttext {
        font-size: 14px;
    }

    /* Estilos para o select */

    .styled-select {
        display: block;
        width: 100%;
        font-size: 15px;
        padding: 0.375rem 1.75rem 0.375rem 0.75rem;
        line-height: 1.5;
        color: #495057;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid #ced4da;
        border-radius: 0.25rem;
        transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    }

    .altcel {
        min-height: 500px !important;
        height: auto !important;
    }

    .altavul {
        padding-top: 25px;
    }

    .btncel {
        color: #ffffff;
        min-width: 80px !important;
        font-size: 18px;
    }

    .controlcelEnd {
        height: 600px;
        width: calc(100% - 248px) !important;
        display: flex;
        flex-direction: column;
    }

}

@media (min-width:768px) {
    .altavul {
        padding-top: 35px;
    }

    .fonttext {
        font-size: 14px;
    }

    /* Estilos para o select */
    .styled-select {
        display: block;
        width: 100%;
        font-size: 15px;
        padding: 0.375rem 1.75rem 0.375rem 0.75rem;
        line-height: 1.5;
        color: #495057;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid #ced4da;
        border-radius: 0.25rem;
        transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    }

    .altcel {
        min-height: 500px !important;
        height: auto !important;
    }

    .altavul {
        padding-top: 25px;
    }

    .btncel {
        color: #ffffff;
        min-width: 80px !important;
        font-size: 18px;
    }
}


@media (max-width:767px) {

    .fonttext {
        font-size: 12px;
    }

    .altcel {
        min-height: 300px !important;
        height: auto !important;
    }

    .altavul {
        padding-top: 5px;
    }

    .text-h5 {
        font-size: 15px !important;
    }

    .btncel {
        color: #ffffff;
        min-width: 80px !important;
        padding: 0 !important;
        font-size: 12px;
    }

    /* Estilos para o select */
    .styled-select {
        display: block;
        width: 100%;
        font-size: 12px;
        padding: 0.375rem 1.75rem 0.375rem 0.75rem;
        line-height: 1.5;
        color: #495057;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid #ced4da;
        border-radius: 0.25rem;
        transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    }

    .v-toolbar-title__placeholder {
        overflow: auto;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .v-toolbar-title {
        flex: auto !important;
        font-size: 1.25rem;
        min-width: 0;
        font-size: 1.25rem;
        font-weight: 400;
        letter-spacing: 0;
        line-height: 1.75rem;
        text-transform: none;
    }

}

.border-green {
    border: 4px solid green !important;
    /* Defina a cor e largura da borda */
    border-radius: 8px;
    /* Adicione um raio de borda para suavizar a aparência */
}

.check-icon {
    position: absolute;
    bottom: 5px;
    /* Ajuste conforme necessário */
    right: 5px;
    /* Ajuste conforme necessário */
    color: green;
    background-color: white;
    border-radius: 50%;
    padding: 5px;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);
    /* Adiciona sombra para destaque */
}

.gp-new-contract-card { overflow: hidden; border: 1px solid #e1d9cd; border-radius: 13px; background: #fffdf9; box-shadow: 0 7px 22px rgba(16,42,90,.06); }
.gp-pending-contracts-card { overflow: hidden; margin-bottom: 16px; border: 1px solid #e1d9cd; border-radius: 13px; background: #fffdf9; box-shadow: 0 7px 22px rgba(16,42,90,.06); }
.gp-pending-contracts-card > .card-header { padding: 13px 16px; border-bottom: 1px solid #e8e1d7; background: #fffdf9; }.gp-pending-contracts-card > .card-body { padding: 12px 16px 16px; }.gp-pending-contracts-card .card-title { margin: 0; color: #102a5a; font-size: 13px; font-weight: 800; }.gp-pending-contracts-card .card-header small { display: block; margin-top: 2px; color: #758197; font-size: 9px; }
.gp-pending-count { display: grid; min-width: 30px; height: 30px; place-items: center; border-radius: 9px; background: #fff0df; color: #c96500; font-size: 11px; font-weight: 850; }.gp-pending-summary { display: flex; max-width: 230px; flex-direction: column; gap: 2px; line-height: 1.25; white-space: normal; }.gp-pending-summary strong { color: #17223b; font-size: 10.5px; }.gp-pending-summary small { color: #718096; font-size: 9px; }.gp-contract-type { display: inline-flex; padding: 4px 8px; border-radius: 999px; font-size: 8.5px; font-weight: 800; }.gp-contract-type.is-initial { background: #e8eef9; color: #1d4f9f; }.gp-contract-type.is-renewal { background: #fff0dd; color: #a95700; }.gp-pending-actions { flex-wrap: nowrap; align-items: center; }.gp-pending-text-action { min-height: 28px; padding: 5px 8px; border: 1px solid; border-radius: 7px; font-size: 8.5px; font-weight: 800; line-height: 1.1; white-space: nowrap; }.gp-pending-text-action.is-analysis { border-color: #b9cbe6; background: #eef4fc; color: #1d4f9f; }.gp-pending-text-action.is-direct { border-color: #acd8c1; background: #eaf8f1; color: #16724b; }.gp-pending-text-action:hover { filter: brightness(.97); }
.gp-new-contract-card > .card-header { padding: 14px 18px; border-bottom: 1px solid #e8e1d7; background: #fffdf9; }
.gp-new-contract-card > .card-body { padding: 14px 18px 20px; }
.gp-new-contract-card :deep(.gp-client-tabs) { margin-bottom: 14px; border: 1px solid #e1d9cd; border-radius: 10px; background: #fcf8f2; }
.gp-new-contract-card :deep(.v-window .v-card) { overflow: hidden; border: 1px solid #e1d9cd !important; border-radius: 12px !important; background: #fffdf9 !important; box-shadow: none !important; }
.gp-new-contract-card :deep(.v-field) { min-height: 38px; border-radius: 9px; background: #fff; }
.gp-new-contract-card :deep(.v-field__input) { min-height: 38px; padding-top: 8px; padding-bottom: 6px; font-size: 11px; }
.gp-new-contract-card label { margin-bottom: 5px; color: #344054; font-size: 10.5px; font-weight: 750; }
.gp-contract-steps { display: grid; grid-template-columns: repeat(5,minmax(0,1fr)); gap: 8px; margin: 0 0 16px; }
.gp-contract-step { display: flex; align-items: center; min-width: 0; min-height: 58px; gap: 9px; padding: 8px 10px; border: 1px solid #e1d9cd; border-radius: 10px; background: #fff; color: #68748a; text-align: left; transition: .18s ease; }
.gp-contract-step:hover { border-color: #e77900; }
.gp-contract-step.is-active { border-color: #e77900; background: #fff7ed; color: #102a5a; box-shadow: inset 3px 0 #e77900; }
.gp-contract-step.is-done { border-color: #bddfce; background: #f3fbf7; color: #176b4a; }
.gp-contract-step-number { display: grid; flex: 0 0 28px; width: 28px; height: 28px; place-items: center; border-radius: 50%; background: #edf1f6; color: #102a5a; font-size: 11px; font-weight: 800; }
.gp-contract-step.is-active .gp-contract-step-number { background: #e77900; color: #fff; }
.gp-contract-step.is-done .gp-contract-step-number { background: #198754; color: #fff; }
.gp-contract-step strong,.gp-contract-step small { display: block; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.gp-contract-step strong { font-size: 10.5px; }.gp-contract-step small { margin-top: 2px; font-size: 8.5px; font-weight: 600; }
.gp-contract-section-card,.gp-contract-review-card,.gp-contract-total-card { margin-top: 0; padding: 16px; }
.gp-contract-section-heading { display: flex; align-items: center; gap: 10px; margin: -16px -16px 16px; padding: 12px 16px; border-bottom: 1px solid #e8e1d7; background: #fcfaf7; }
.gp-contract-section-heading > span { display: grid; flex: 0 0 32px; width: 32px; height: 32px; place-items: center; border-radius: 9px; background: #fff0df; color: #d76d00; }
.gp-contract-section-heading h5 { margin: 0; color: #102a5a; font-size: 13px; font-weight: 800; }.gp-contract-section-heading small { display: block; margin-top: 2px; color: #758197; font-size: 9.5px; }
.gp-contract-total-card { margin-top: 12px; border-left: 3px solid #e77900 !important; }
.gp-contract-item-card { overflow: hidden; margin-bottom: 10px; border: 1px solid #e8e1d7; border-radius: 10px; background: #fff; }
.gp-contract-item-card:last-child { margin-bottom: 0; }
.gp-contract-item-title { display: flex; align-items: center; justify-content: space-between; gap: 10px; padding: 10px 12px; border-bottom: 1px solid #eee8df; background: #fcfaf7; }.gp-contract-item-title strong,.gp-contract-item-title small { display: block; }.gp-contract-item-title strong { color: #102a5a; font-size: 11.5px; }.gp-contract-item-title small { margin-top: 2px; color: #758197; font-size: 8.5px; }.gp-contract-item-actions { display: flex; gap: 6px; }.gp-contract-item-title button { display: grid; width: 29px; height: 29px; place-items: center; border: 1px solid #f1c8cd; border-radius: 7px; background: #fff; color: #dc3545; }.gp-contract-item-title button.is-edit { border-color: #bfd2f4; color: #0d5bd7; }
.gp-contract-item-details { display: grid; grid-template-columns: repeat(6,minmax(0,1fr)); gap: 0; padding: 10px 12px; }.gp-contract-item-details > div { min-width: 0; padding: 3px 10px; border-right: 1px solid #eee8df; }.gp-contract-item-details > div:first-child { padding-left: 0; }.gp-contract-item-details > div:last-child { padding-right: 0; border-right: 0; }.gp-contract-item-details small,.gp-contract-item-details strong { display: block; }.gp-contract-item-details small { color: #7a8495; font-size: 8px; font-weight: 800; text-transform: uppercase; }.gp-contract-item-details strong { overflow: hidden; margin-top: 4px; color: #344054; font-size: 10px; text-overflow: ellipsis; white-space: nowrap; }
.gp-contract-item-validity { display: flex; align-items: center; gap: 6px; padding: 8px 12px; border-top: 1px solid #eee8df; background: #f7faff; color: #53647c; font-size: 9.5px; }
.gp-payment-options { display: grid; grid-template-columns: repeat(3,minmax(0,1fr)); gap: 10px; margin-bottom: 12px; }
.gp-payment-check { display: flex; align-items: flex-start; gap: 9px; margin: 0 !important; padding: 11px 12px; border: 1px solid #e1d9cd; border-radius: 9px; background: #fff; cursor: pointer; }
.gp-payment-check input { width: 16px; height: 16px; margin-top: 1px; accent-color: #e77900; }
.gp-payment-check span,.gp-payment-check strong,.gp-payment-check small { display: block; }.gp-payment-check strong { color: #102a5a; font-size: 10.5px; }.gp-payment-check small { margin-top: 2px; color: #758197; font-size: 9px; }
.gp-payment-summary { display: grid; grid-template-columns: repeat(3,minmax(0,1fr)); gap: 8px; margin-top: 12px; padding-top: 12px; border-top: 1px solid #e8e1d7; }
.gp-payment-summary-link-only { grid-template-columns: 1fr; }
.gp-payment-summary > div { padding: 11px 12px; border: 1px solid #e8e1d7; border-radius: 9px; background: #fcfaf7; }.gp-payment-summary small,.gp-payment-summary strong,.gp-payment-summary span { display: block; }.gp-payment-summary small { color: #758197; font-size: 8.5px; font-weight: 800; text-transform: uppercase; }.gp-payment-summary strong { margin-top: 4px; color: #102a5a; font-size: 12px; }.gp-payment-summary span { margin-top: 2px; color: #68748a; font-size: 9px; }
.gp-review-grid { display: grid; grid-template-columns: repeat(2,minmax(0,1fr)); gap: 10px; }
.gp-review-grid section { position: relative; display: flex; min-height: 104px; flex-direction: column; padding: 13px; border: 1px solid #e8e1d7; border-radius: 10px; background: #fff; }
.gp-review-grid small { color: #788397; font-size: 9px; font-weight: 800; text-transform: uppercase; }.gp-review-grid strong { margin-top: 6px; color: #102a5a; font-size: 11.5px; }.gp-review-grid span { margin-top: 4px; color: #667085; font-size: 10px; }
.gp-review-grid button { align-self: flex-end; margin-top: auto; border: 0; background: transparent; color: #d76d00; font-size: 9.5px; font-weight: 800; }
.gp-review-alert { display: flex; align-items: center; gap: 8px; margin-top: 12px; padding: 10px 12px; border: 1px solid #cfe0f5; border-radius: 9px; background: #f4f8fd; color: #31547d; font-size: 10px; }
.gp-new-contract-actions { align-items: center; justify-content: flex-end; margin-top: 16px; padding-top: 16px; border-top: 1px solid #e8e1d7; }
.gp-new-contract-actions > div { display: flex; justify-content: flex-end; }
.gp-contract-actionbar { align-items: center; gap: 8px; }.gp-action-spacer { flex: 1; }
.gp-new-contract-actions .btn { min-height: 36px; border-radius: 9px; font-size: 10.5px; font-weight: 750; }
.gp-new-contract-actions .btn-primary { border-color: #e77900; background: #e77900; color: #fff; }
.gp-new-contract-actions .btn-secondary { border-color: #102a5a; background: #102a5a; color: #fff; }
.gp-new-contract-dialog.controlcelEnd { width: auto !important; height: auto !important; }
.gp-new-contract-dialog :deep(.v-overlay__scrim) { opacity: .58 !important; }
.gp-new-contract-dialog :deep(.v-overlay__content) { width: calc(100% - 32px); max-height: calc(100vh - 32px); margin: 16px; }
.gp-product-dialog :deep(.v-overlay__content) { max-width: 820px; }
.gp-address-dialog :deep(.v-overlay__content) { max-width: 760px; }
.gp-quick-client-dialog :deep(.v-overlay__content) { max-width: 940px; }
.gp-quick-client-block { margin-bottom: 12px; padding: 12px; border: 1px solid #e8e1d7; border-radius: 10px; background: #fff; }
.gp-quick-client-block:last-child { margin-bottom: 0; }
.gp-quick-client-heading { margin: -12px -12px 12px; padding: 10px 12px; border-bottom: 1px solid #e8e1d7; background: #fcfaf7; }
.gp-quick-client-heading strong { display: block; color: #102a5a; font-size: 11.5px; }.gp-quick-client-heading small { display: block; margin-top: 2px; color: #758197; font-size: 9px; }
.gp-quick-address-note { display: block; margin: -2px 0 0 32px; color: #758197; font-size: 9px !important; }
.gp-new-contract-dialog :deep(.v-card) { display: flex; overflow: hidden; max-height: calc(100vh - 32px); flex-direction: column; border: 1px solid #e1d9cd; border-radius: 14px; background: #fffdf9; box-shadow: 0 18px 55px rgba(16,42,90,.2); }
.gp-new-contract-dialog :deep(.v-card-title) { display: flex; align-items: center; justify-content: space-between; min-height: 54px; padding: 13px 16px !important; border-bottom: 1px solid #e8e1d7; background: #fffdf9 !important; color: #102a5a; font-size: 14px !important; font-weight: 800; }
.gp-dialog-title { display: inline-flex; align-items: center; gap: 8px; color: #102a5a; font-size: 14px; font-weight: 800; }
.gp-dialog-title :deep(.v-icon) { color: #e77900; }
.gp-dialog-close { display: grid; width: 32px; height: 32px; place-items: center; border: 1px solid #e1d9cd; border-radius: 8px; background: #fff; color: #102a5a; }
.gp-dialog-close:hover { border-color: #e77900; color: #e77900; }
.gp-new-contract-dialog :deep(.v-card-text) { overflow-y: auto; padding: 12px 16px !important; }
.gp-new-contract-dialog :deep(.v-container) { max-width: none; padding: 0; }
.gp-new-contract-dialog :deep(.v-row) { margin: -5px; }
.gp-new-contract-dialog :deep(.v-col) { padding: 5px; }
.gp-new-contract-dialog :deep(.v-field) { min-height: 36px; border-radius: 8px; background: #fff; }
.gp-new-contract-dialog :deep(.v-field__input) { min-height: 36px; padding-top: 7px; padding-bottom: 5px; font-size: 11px; }
.gp-new-contract-dialog :deep(.v-input__details) { display: none; }
.gp-new-contract-dialog .form-control { min-height: 36px; border-color: #d8d2c8; border-radius: 8px; font-size: 11px; }
.gp-new-contract-dialog small,.gp-new-contract-dialog label,.gp-new-contract-dialog strong { font-size: 10.5px; }
.gp-product-dialog :deep(.v-alert) { margin-top: 8px; padding: 8px 10px !important; font-size: 10px; }
.gp-product-dialog :deep(.v-alert-title) { font-size: 11px; }
.gp-product-value-row { align-items: center; min-height: 44px; margin: 0 !important; border-bottom: 1px solid #eee8df; line-height: 1.3 !important; }
.gp-product-value-row:last-of-type { border-bottom: 0; }
.gp-product-value-label { min-width: 0; color: #344054; font-size: 10.5px; font-weight: 650; white-space: normal; word-break: normal; }
.gp-product-value-row :deep(.v-input) { width: 100%; }
.gp-percentage-input { position: relative; }
.gp-percentage-input input { padding-right: 30px; }
.gp-percentage-input span { position: absolute; top: 50%; right: 11px; color: #68748a; font-size: 11px; font-weight: 750; pointer-events: none; transform: translateY(-50%); }
.gp-product-dialog :deep(.v-card-text .v-card) { min-height: 0; padding: 10px !important; border-radius: 9px !important; font-size: 11px; line-height: 1.5; }
.gp-guarantee-result { display: flex; flex-direction: column; gap: 7px; }
.gp-guarantee-result-title { display: block; color: #344054; font-weight: 750; }
.gp-guarantee-result :deep(.v-card) { margin: 0 !important; background: #f3f7fc !important; color: #102a5a; }
.gp-guarantee-disclaimer { display: block; color: #788397; font-size: 9.5px !important; line-height: 1.45; }
.gp-property-type-options { display: grid; grid-template-columns: repeat(2,minmax(0,1fr)); gap: 6px; }
.gp-property-type-options button { display: inline-flex; align-items: center; justify-content: center; min-height: 36px; gap: 5px; border: 1px solid #d8d2c8; border-radius: 8px; background: #fff; color: #596579; font-size: 10.5px; font-weight: 700; }
.gp-property-type-options button:hover { border-color: #e77900; color: #c96500; }
.gp-property-type-options button.is-active { border-color: #e77900; background: #fff3e5; color: #b85d00; box-shadow: inset 3px 0 #e77900; }
.gp-address-search-button { display: inline-flex; align-items: center; justify-content: center; min-height: 36px; margin-top: 20px; padding: 7px 14px; border: 1px solid #102a5a; border-radius: 8px; background: #102a5a; color: #fff !important; font-size: 10.5px; font-weight: 750; }
.gp-dialog-primary-action { min-height: 36px !important; padding: 0 15px !important; border-radius: 8px !important; background: #e77900 !important; color: #fff !important; font-size: 10.5px !important; font-weight: 800 !important; letter-spacing: 0 !important; }
.gp-dialog-secondary-action { min-height: 36px !important; padding: 0 15px !important; border: 1px solid #aeb6c2 !important; border-radius: 8px !important; background: #fff !important; color: #596579 !important; font-size: 10.5px !important; font-weight: 750 !important; letter-spacing: 0 !important; }
.gp-new-contract-dialog :deep(.v-card-actions) { flex: 0 0 auto; min-height: 58px; padding: 10px 16px; border-top: 1px solid #e8e1d7; background: #fffdf9; }
.gp-new-contract-dialog :deep(.v-card-actions .v-btn) { min-height: 34px; border-radius: 8px; font-size: 10.5px !important; font-weight: 750; }

@media (max-width: 767.98px) {
    .gp-new-contract-card > .card-body { padding: 12px; }
    .gp-new-contract-actions > div { justify-content: stretch; }
    .gp-new-contract-actions .btn { width: 100%; }
    .gp-new-contract-dialog :deep(.v-overlay__content) { width: calc(100% - 16px); max-height: calc(100vh - 16px); margin: 8px; }
    .gp-new-contract-dialog :deep(.v-card) { max-height: calc(100vh - 16px); }
    .gp-product-dialog :deep(.v-card-text > .v-form > .v-container > .v-row) { flex-direction: column; }
    .gp-product-value-row { min-height: 0; padding: 5px 0; }
    .gp-property-type-options { grid-template-columns: 1fr; }
    .gp-contract-steps { display: flex; overflow-x: auto; padding-bottom: 4px; }
    .gp-contract-step { flex: 0 0 126px; }
    .gp-review-grid { grid-template-columns: 1fr; }
    .gp-payment-options,.gp-payment-summary { grid-template-columns: 1fr; }
    .gp-contract-item-details { grid-template-columns: repeat(2,minmax(0,1fr)); }.gp-contract-item-details > div { padding: 7px 8px; border-right: 0; border-bottom: 1px solid #eee8df; }.gp-contract-item-details > div:nth-last-child(-n+2) { border-bottom: 0; }
    .gp-contract-actionbar { flex-direction: column; align-items: stretch; }
    .gp-action-spacer { display: none; }
}
</style>
